import { useTranslation } from "react-i18next";
import "./AmFund.scss";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import newRequest from '../../../utils/newRequest';
import { GridLoader, ScaleLoader } from "react-spinners";
import { motion } from "framer-motion";
import numeral from "numeral";
import { MdAdd, MdClose, MdDelete, MdEmail, MdOutlineNumbers, MdPhone, MdSave, MdDragIndicator } from 'react-icons/md';
import { IoDocumentTextSharp } from 'react-icons/io5';
import CircularButton, { CustomLoadingButton } from "../../../components/ui/CustomButton";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import app from "../../../utils/firebase";
import moment from "moment";
import {
    getStorage,
    ref,
    uploadBytesResumable,
    getDownloadURL,
} from "firebase/storage";
import OnScreenReports from "../../../components/onScreenReports/OnScreenReports";
import {
    Table,
    TablePagination,
    TableContainer,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    DialogActions,
    Dialog,
    DialogTitle,
    DialogContent,
    Tooltip,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio
} from "@mui/material";


import ConfirmDialog from "../../../components/confirmDialog/confirmDialog";
import { IoIosRefresh } from "react-icons/io";
import ExpandableComponent from "../../../components/expandableComponent/ExpandableComponent";
import { showToast } from "../../../toastService";
import { fetchClientsBySearch, formatAmountsToDecimals, formatNumber, formatStringToNumberV2, getFirstName } from "../../../utils/genericFunctions";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect";
import { CiImageOn } from "react-icons/ci";
import UploadDialog from "../../../components/uploadDialog/UploadDialog";
import { TbCertificate } from "react-icons/tb";
import ValidationMessages from "../../../components/validationMessages/ValidationMessages";

const AmFund = () => {
    const { t } = useTranslation();
    const [isProcessing, setIsProcessing] = useState(false);
    const { currentUser } = useSelector((state) => state.user);
    const { currentTheme } = useSelector((state) => state.theme);
    const [isLoading, setIsLoading] = useState(false);
    const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
    const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
    const [notifyDialogText, setNotifyDialogText] = useState("Text");
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const navigate = useNavigate();
    const { docid } = useParams();
    const [fundDocId, setFundDocId] = useState(null);
    const [fundData, setFundData] = useState(null);
    const [fundTypes, setFundTypes] = useState([]);
    const [horizonTypes, setHorizonTypes] = useState([]);
    const [investorTypes, setInvestorTypes] = useState([]);
    const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
    const [confirmDialogAction, setConfirmDialogAction] = useState("None");
    const [confirmationActiontext, setConfirmationActiontext] = useState("");
    const [documentEnabled, setDocumentEnabled] = useState("Y");
    const [saveEnabled, setSaveEnabled] = useState("Y");
    const [nextAction, setNextAction] = useState("Activate");
    const [reportsDialogOpen, setReportsDialogOpen] = useState(false);
    const [traceData, setTraceData] = useState([]);
    const [benchmarks, setBenchmarks] = useState([]);
    const benchmarkTypes = ['Absolute', 'Relative'];

    const [assetAllocation, setAssetAllocation] = useState([]);
    const [selectedAsset, setSelectedAsset] = useState(null);

    const [eligibleInvestors, setEligibleInvestors] = useState([]);
    const [selectedInvestor, setSelectedInvestor] = useState(null);
    const [supportedCurrencies, setSupportedCurrencies] = useState([]);
    const [complianceTags, setComplianceTags] = useState([]);

    const [definedRegions, setDefinedRegions] = useState([]);
    const [selectedRegion, setSelectedRegion] = useState(null);

    const [definedSectors, setDefinedSectors] = useState([]);
    const [selectedSector, setSelectedSector] = useState(null);

    const [definedSubSectors, setDefinedSubSectors] = useState([]);
    const [selectedSubSector, setSelectedSubSector] = useState(null);

    const [allowedRegions, setAllowedRegions] = useState([]);
    const [allowedSectors, setAllowedSectors] = useState([]);
    const [allowedSubSectors, setAllowedSubSectors] = useState([]);

    const [assetClasses, setAssetClasses] = useState([]);
    const [selectedAssetClass, setSelectedAssetClass] = useState(null);

    const [fees, setFees] = useState([]);
    const [selectedFee, setSelectedFee] = useState(null);

    const [definedFees, setDefinedFees] = useState([]);
    const [selectedDefinedFee, setSelectedDefinedFee] = useState(null);

    const [totalAllocation, setTotalAllocation] = useState(0);

    const [selectedCustodian, setSelectedCustodian] = useState(null);
    const [selectedTrustee, setSelectedTrustee] = useState(null);
    const [selectedAuditor, setSelectedAuditor] = useState(null);

    const [fundClassTypes, setFundClassTypes] = useState([]);
    const [valuationMethods, setValuationMethods] = useState([]);
    const [distributionPolicies, setDistributionPolicies] = useState([]);

    const [fundRateTypes, setFundRateTypes] = useState([]);
    const [frequencies, setFrequencies] = useState([]);
    const [fundRateFrequencies, setFundRateFrequencies] = useState([]);
    const [fundRateApplOn, setFundRateApplOn] = useState([]);
    const [triggerConditions, setTriggerConditions] = useState([]);
    const [riskProfiles, setRiskProfiles] = useState([]);
    const [rebalanceMethods, setRebalanceMethods] = useState([]);

    const [validationMsgDialog, setValidationMsgDialog] = useState(false);
    const [validationMessagesResult, setValidationMessagesResult] = useState({});

    // firebase uploads
    const [img, setImg] = useState(undefined);
    const [imgPerc, setImgPerc] = useState(0);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [file, setFile] = useState(null);

    const [rowsPerPageFees, setRowsPerPageFees] = useState(3);
    const [currentFeesPage, setCurrentFeesPage] = useState(0);

    const handleFeesPageChange = (event, newPage) => {
        setCurrentFeesPage(newPage);
    };

    const slicedFees = fees?.slice(
        currentFeesPage * rowsPerPageFees,
        currentFeesPage * rowsPerPageFees + rowsPerPageFees
    );

    const handleFeesRowsPerPage = (event) => {
        setRowsPerPageFees(parseInt(event.target.value, 3));
        setCurrentFeesPage(0);
    };


    const handleConfirm = async () => {
        try {
            if (confirmDialogAction === "Activate") {
                let validateResponse = null;
                try {
                    // validateResponse = await newRequest.get(`/fund/validate/${fundDocId}`, { timeout: 5000 });
                    validateResponse = await newRequest.get(`/fund/validate/${fundDocId}`);
                } catch (error) {
                    if (error.code === 'ECONNABORTED') {
                        console.error("Request timed out!");
                        showToast(t('requestTimedOut'), "error");
                    } else {
                        console.error("Other error:", error.message);
                        showToast(error.message, "error");
                    }
                }
                if (validateResponse.data.result_status === "error") {
                    setIsProcessing(false);
                    setIsConfirmDialogOpen(false);
                    setValidationMessagesResult(validateResponse.data);
                    setValidationMsgDialog(true);
                    return;
                }
                await newRequest.put(`/fund/upd/${fundDocId}`, { fund_status: "Active" }, { timeout: 5000 });
                await fetchFund(fundDocId, true);
                showToast(t('fundActivated', { param1: fundData?.fund_name }), "success");
            } else if (confirmDialogAction === "Pause") {
                await newRequest.put(`/fund/upd/${fundDocId}`, { fund_status: "Paused" }, { timeout: 5000 });
                await fetchFund(fundDocId, true);
                showToast(t('fundPaused', { param1: fundData?.fund_name }), "success");
            }
        } catch (err) {
            console.log(err);
        }
        setIsConfirmDialogOpen(false);
    };


    useEffect(() => {
        img && uploadToFirebase(img, "am_funds");
    }, [img]);

    const uploadToFirebase = async (file, fileFolder) => {
        setIsDialogOpen(true);
        const storage = getStorage(app);
        const fileName = new Date().getTime() + file.name;
        const fileExtension = file.name.split(".").pop(); // Get file extension
        const fileType = file.type; // Get file type
        const fileSizeKB = file.size / 1024; // Get file size in KB
        const storageRef = ref(
            storage,
            `qc_${currentUser.usr_org_code}/${fileFolder}/${fileName}`
        );
        const uploadTask = uploadBytesResumable(storageRef, file);

        // console.log(`fileName  ${fileName}`);
        // console.log(`fileExtension  ${fileExtension}`);
        // console.log(`fileType  ${fileType}`);
        // console.log(`fileSizeKB  ${fileSizeKB}`);
        // console.log(`storageRef  ${storageRef}`);

        uploadTask.on(
            "state_changed",
            (snapshot) => {
                const progress =
                    (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                setUploadProgress(Math.round(progress));
                switch (snapshot.state) {
                    case "paused":
                        console.log("Upload is paused");
                        break;
                    case "running":
                        console.log("Upload is running");
                        break;
                    default:
                        break;
                }
            },
            (error) => {
                setIsDialogOpen(false);
                console.log(error);
            },
            async () => {
                const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                // update fund logo url
                try {
                    const res = await newRequest.put(`/fund/upd/${fundData?._id}`, { fund_logo_url: downloadURL });
                    handleSetFundData("fund_logo_url", downloadURL);
                    setIsDialogOpen(false);
                } catch (error) {
                    console.log(error);
                    setIsDialogOpen(false);
                }

            }
        );
    };


    const saveRecord = async (e) => {
        try {
            // check rebalancing rule
            if (fundData?.rebalance_method === 'Threshold-Based' && parseFloat(formatStringToNumberV2(fundData?.rebalance_threshold || 0)) === 0) {
                setNotifyDialogTitle(t('error'));
                setNotifyDialogText(`${t('rebalancingRuleError', { method: fundData?.rebalance_method })}`);
                setIsNotifyDialogOpen(true);
                return;
            }

            const formattedFees = fees?.map(line => ({
                ...line,
                rate: parseFloat(formatStringToNumberV2(line?.rate, 2)),
            }));


            // update fund info
  
            await newRequest.put(`/fund/upd/${fundData?._id}`, {
                ...fundData,
                nav_per_unit: parseFloat(formatStringToNumberV2(fundData?.nav_per_unit || 0)),
                minimum_subscription: parseFloat(formatStringToNumberV2(fundData?.minimum_subscription || 0)),
                aum_cap: parseFloat(formatStringToNumberV2(fundData?.aum_cap || 0)),
                expected_aum: parseFloat(formatStringToNumberV2(fundData?.expected_aum || 0)),
                benchmark_target: parseFloat(formatStringToNumberV2(fundData?.benchmark_target || 0)),
                rebalance_threshold: parseFloat(formatStringToNumberV2(fundData?.rebalance_threshold || 0)),
                fund_custodian_docid: selectedCustodian?.ent_docid,
                fund_custodian_ent: selectedCustodian?.value,
                fund_trustee_docid: selectedTrustee?.ent_docid,
                fund_trustee_ent: selectedTrustee?.value,
                fund_auditor_docid: selectedAuditor?.ent_docid,
                fund_auditor_ent: selectedAuditor?.value,

                asset_allocation: assetAllocation || [],
                fees: formattedFees || [],

                eligible_investors: eligibleInvestors || [],
                supported_currencies: supportedCurrencies || [],
                compliance_tags: complianceTags || [],

                allowed_regions: allowedRegions.map(item => item.region) || [],
                allowed_sectors: allowedSectors.map(item => item.sector) || [],
                allowed_sub_sectors: allowedSubSectors.map(item => item.sub_sector) || [],


            });

            setNotifyDialogTitle(t('success'));
            setNotifyDialogText(t('successSaved', { param1: fundData?.fund_name }));
            setIsNotifyDialogOpen(true);

        } catch (err) {
            console.log(err);
        }
    };

    const handleSetFundData = (name, value) => {
        setFundData((prev) => {
            return { ...prev, [name]: value };
        });
    };

    const handleBenchmarkChange = (event) => {
        handleSetFundData('benchmark_target_type', event.target.value);
    };

    const fetchFund = async (doc_id, firstTime = false) => {
        try {
            if (firstTime) {
                setIsLoading(true);
            }
            const res = await newRequest.post("/fund/find/", { fund_docid: doc_id, monitor: "N" });
            if (res.data) {

                setFundDocId(res.data?._id);
                setDocumentEnabled(res.data?.document_enabled_xx);
                setSaveEnabled(res.data?.save_enabled_xx);
                setNextAction(res.data?.next_action_xx);

                setEligibleInvestors(res.data?.eligible_investors);
                setSupportedCurrencies(res.data?.supported_currencies);
                setComplianceTags(res.data?.compliance_tags);

                setAllowedRegions(res.data?.allowed_regions);
                setAllowedSectors(res.data?.allowed_sectors);
                setAllowedSubSectors(res.data?.allowed_sub_sectors);

                const formattedData = {
                    ...res.data,
                    nav_per_unit: formatAmountsToDecimals(res.data?.nav_per_unit || 0),
                    minimum_subscription: formatAmountsToDecimals(res.data?.minimum_subscription || 0),
                    aum_cap: formatAmountsToDecimals(res.data?.aum_cap || 0),
                    expected_aum: formatAmountsToDecimals(res.data?.expected_aum || 0),
                    benchmark_target: formatAmountsToDecimals(res.data?.benchmark_target || 0),
                    rebalance_threshold: formatAmountsToDecimals(res.data?.rebalance_threshold || 0),
                    launch_date: res.data?.launch_date ? moment(res.data?.launch_date).format("YYYY-MM-DD") : null,
                };

                setFundData(formattedData);
                await fetchTrace(res.data?.fund_code);

                const formattedAllocation = res.data?.asset_allocation?.map(line => ({
                    ...line,
                    target_weight: formatAmountsToDecimals(line?.target_weight, 2),
                    min_weight: formatAmountsToDecimals(line?.min_weight, 2),
                    max_weight: formatAmountsToDecimals(line?.max_weight, 2),
                }));
                setAssetAllocation(formattedAllocation);


                const formattedFees = res.data?.fees?.map(line => ({
                    ...line,
                    rate: formatAmountsToDecimals(line?.rate, 2),
                }));
                setFees(formattedFees);

                if (res.data?.custodian_xx) {
                    setSelectedCustodian({
                        ent_docid: res.data?.custodian_xx?._id,
                        ent_email: res.data?.custodian_xx?.ent_email,
                        ent_phone_no: res.data?.custodian_xx?.ent_phone_no,
                        ent_photo_url: res.data?.custodian_xx?.ent_photo_url,
                        ent_status: res.data?.custodian_xx?.ent_status,
                        aent_name_xx: res.data?.custodian_xx?.aent_name_xx,
                        ent_code: res.data?.custodian_xx?.ent_code,
                        ent_aent_code: res.data?.custodian_xx?.ent_aent_code,
                        ent_name: res.data?.custodian_xx?.ent_name,
                        value: res.data?.custodian_xx?.ent_code,
                        label: (
                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginRight: "5px" }}>
                                {res.data?.custodian_xx?.ent_name}
                            </div>
                        ),
                    });
                } else {
                    setSelectedCustodian(null);
                }


                if (res.data?.trustee_xx) {
                    setSelectedTrustee({
                        ent_docid: res.data?.trustee_xx?._id,
                        ent_email: res.data?.trustee_xx?.ent_email,
                        ent_phone_no: res.data?.trustee_xx?.ent_phone_no,
                        ent_photo_url: res.data?.trustee_xx?.ent_photo_url,
                        ent_status: res.data?.trustee_xx?.ent_status,
                        aent_name_xx: res.data?.trustee_xx?.aent_name_xx,
                        ent_code: res.data?.trustee_xx?.ent_code,
                        ent_aent_code: res.data?.trustee_xx?.ent_aent_code,
                        ent_name: res.data?.trustee_xx?.ent_name,
                        value: res.data?.trustee_xx?.ent_code,
                        label: (
                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginRight: "5px" }}>
                                {res.data?.trustee_xx?.ent_name}
                            </div>
                        ),
                    });
                } else {
                    setSelectedTrustee(null);
                }


                if (res.data?.auditor_xx) {
                    setSelectedAuditor({
                        ent_docid: res.data?.auditor_xx?._id,
                        ent_email: res.data?.auditor_xx?.ent_email,
                        ent_phone_no: res.data?.auditor_xx?.ent_phone_no,
                        ent_photo_url: res.data?.auditor_xx?.ent_photo_url,
                        ent_status: res.data?.auditor_xx?.ent_status,
                        aent_name_xx: res.data?.auditor_xx?.aent_name_xx,
                        ent_code: res.data?.auditor_xx?.ent_code,
                        ent_aent_code: res.data?.auditor_xx?.ent_aent_code,
                        ent_name: res.data?.auditor_xx?.ent_name,
                        value: res.data?.auditor_xx?.ent_code,
                        label: (
                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginRight: "5px" }}>
                                {res.data?.auditor_xx?.ent_name}
                            </div>
                        ),
                    });
                } else {
                    setSelectedAuditor(null);
                }

                if (res.data?.document_enabled_xx === "Y") {
                    await callDetailsFunction();
                }
            }
        } catch (err) {
            console.log(err);
        } finally {
            if (firstTime) {
                setIsLoading(false);
            }
        }
    };

    const fetchTrace = async (fundCode) => {
        try {
            const res = await newRequest.post(
                "/trace/findDoc",
                {
                    trc_doc_type: "AM Fund",
                    trc_doc_no: fundCode
                }
            );
            setTraceData(res.data);
        } catch (err) {
            console.log(err);
        }
    };

    const fetchFundTypes = async () => {
        try {
            const res = await newRequest.post(
                "/sysCode/findAll", { sys_type: "Fund Types" }
            );
            const options = res.data?.map((codes) => ({
                value: codes?.sys_code,
                label: codes?.sys_code,
            }));

            setFundTypes(options);
        } catch (error) {
            console.error("Error fetching fund types :", error);
        }
    };

    const fetchAssetClasses = async () => {
        try {
            const res = await newRequest.post("/sysCode/findAll", { sys_type: "Asset Classes" });
            const options = res.data?.map((codes) => ({
                value: codes?.sys_code,
                label: codes?.sys_name,
            }));
            setAssetClasses(options);
        } catch (error) {
            console.error("Error fetching fund types :", error);
        }
    };

    const fetchDefinedFees = async () => {
        try {
            const res = await newRequest.post("/sysCode/findAll", { sys_type: "Fund Fees" });
            const options = res.data?.map((codes) => ({
                fee_type: codes?.sys_grouping,
                value: codes?.sys_code,
                label: codes?.sys_name,
            }));
            setDefinedFees(options);
        } catch (error) {
            console.error("Error fetching fund types :", error);
        }
    };

    const fetchDefinedRegions = async () => {
        try {
            const res = await newRequest.post("/sysCode/findAll", { sys_type: "Fund Regions" });
            const options = res.data?.map((codes) => ({
                value: codes?.sys_code,
                label: codes?.sys_name,
            }));

            setDefinedRegions(options);
        } catch (error) {
            console.error("Error fetching fund types :", error);
        }
    };

    const fetchDefinedSectors = async () => {
        try {
            const res = await newRequest.post(
                "/sysCode/findNullGrp", { sys_type: "AM Sectors" }
            );
            const options = res.data?.map((codes) => ({
                value: codes?.sys_code,
                label: codes?.sys_name,
            }));

            setDefinedSectors(options);
        } catch (error) {
            console.error("Error fetching defined sectors :", error);
        }
    };

    const fetchDefinedSubSectors = async () => {
        try {
            // console.log(`allowedSectors ${JSON.stringify(allowedSectors, null, 2)}`);
            const sectorCodes = allowedSectors.map(item => item.sector);
            const res = await newRequest.post("/sysCode/getMultipleGroups", { sys_type: "AM Sectors", groups_array: sectorCodes });
            const options = res.data?.map((codes) => ({
                value: codes?.sys_code,
                label: codes?.sys_name,
            }));
            // console.log(`setDefinedSubSectors ${JSON.stringify(options, null, 2)}`);
            setDefinedSubSectors(options);
        } catch (error) {
            console.error("Error fetching defined sectors :", error);
        }
    };

    const fetchHorizonTypes = async () => {
        try {
            const res = await newRequest.post("/sysCode/findAll", { sys_type: "Investment Horizon" });
            const options = res.data?.map((codes) => ({
                value: codes?.sys_code,
                label: codes?.sys_code,
            }));
            setHorizonTypes(options);
        } catch (error) {
            console.error("Error fetching fund types :", error);
        }
    };

    const fetchInvestorTypes = async () => {
        try {
            const res = await newRequest.post(
                "/sysCode/findAll", { sys_type: "Investor Type" }
            );
            const options = res.data?.map((codes) => ({
                value: codes?.sys_code,
                label: codes?.sys_code,
            }));
            setInvestorTypes(options);
        } catch (error) {
            console.error("Error fetching fund types :", error);
        }
    };

    const fetchBenchmarks = async () => {
        try {
            const res = await newRequest.post("/benchmark/findAll", { result_limit: 100 });
            const options = res.data?.map((codes) => ({
                docid: codes?._id,
                value: codes?.benchmark_code,
                label: codes?.benchmark_name,
            }));
            setBenchmarks(options);
        } catch (error) {
            console.error("Error fetching fund types :", error);
        }
    };

    const fetchFeesDetails = async () => {
        try {

            const rateTypes = ['Percentage', 'Fixed Amount']?.map((code) => ({
                value: code,
                label: code,
            }));
            setFundRateTypes(rateTypes);

            const freqs = ['Annual', 'Quarterly', 'Monthly', 'Weekly', 'Daily']?.map((code) => ({
                value: code,
                label: code,
            }));

            setFrequencies(freqs);

            const rateAt = [
                ...freqs,
                { value: 'Per Transaction', label: 'Per Transaction' }
            ];
            setFundRateFrequencies(rateAt);

            const ratesOn = ['AUM', 'NAV', 'Gain', 'Transaction Amount']?.map((code) => ({
                value: code,
                label: code,
            }));
            setFundRateApplOn(ratesOn);

            const triggerConds = ["On Subscription", "On Redemption", "On Switch", "On Gain", "On Loss", 'On EOD', 'On EOW', 'On EOM', 'On EOQ', 'On EOY']?.map((code) => ({
                value: code,
                label: code,
            }));
            setTriggerConditions(triggerConds);

            const rebalanceMethods = ['Threshold-Based', 'Calendar-Based']?.map((code) => ({
                value: code,
                label: code,
            }));
            setRebalanceMethods(rebalanceMethods);


            const profiles = ['Low', 'Moderate', 'High']?.map((code) => ({
                value: code,
                label: code,
            }));
            setRiskProfiles(profiles);


            const fundClassTypes = ['Standalone', 'Umbrella', 'Sub-Fund']?.map((code) => ({
                value: code,
                label: code,
            }));
            setFundClassTypes(fundClassTypes);

            const valuationMethods = ['Mark-to-Market', 'Amortized Cost', 'Hybrid']?.map((code) => ({
                value: code,
                label: code,
            }));
            setValuationMethods(valuationMethods);
            const distPolicies = ['Reinvest', 'Pay Out', 'Hybrid']?.map((code) => ({
                value: code,
                label: code,
            }));
            setDistributionPolicies(distPolicies);

        } catch (error) {
            console.error("Error :", error);
        }
    };

    const handleAssetClassChange = (e, id, field) => {
        try {
            const newSmiData = [...assetAllocation];
            const index = newSmiData.findIndex(smi => smi._id === id);
            if (index !== -1) {
                newSmiData[index][field] = e.target.value;
                setAssetAllocation(newSmiData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleAssetClassBlur = (id, field) => {
        try {
            const updatedData = [...assetAllocation];
            const index = updatedData.findIndex(smi => smi._id === id);
            if (index !== -1) {
                // const value = formatStringToNumberV2(updatedData[index][field]);
                const value = updatedData[index][field];
                updatedData[index][field] = formatNumber(formatStringToNumberV2(value));
                updatedData[index]["changed_xx"] = "Y";
                setAssetAllocation(updatedData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleFundFeeChange = (e, id, field) => {
        try {
            const newSmiData = [...fees];
            const index = newSmiData.findIndex(smi => smi._id === id);
            if (index !== -1) {
                if (e && e.target) {
                    // Regular input
                    newSmiData[index][field] = e.target.value;
                } else if (e && typeof e === "object") {
                    // react-select returns the whole selected option object
                    newSmiData[index][field] = e.value;
                }
                setFees(newSmiData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleFundFeeBlur = (id, field) => {
        try {
            const updatedData = [...fees];
            const index = updatedData.findIndex(smi => smi._id === id);
            if (index !== -1) {
                const value = updatedData[index][field];
                if (field === "rate") {
                    updatedData[index][field] = formatNumber(formatStringToNumberV2(value));
                } else {
                    updatedData[index][field] = value;
                }
                updatedData[index]["changed_xx"] = "Y";
                setFees(updatedData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const callDetailsFunction = async () => {
        try {
            await fetchFundTypes();
            await fetchHorizonTypes();
            await fetchAssetClasses();
            await fetchDefinedFees();
            await fetchBenchmarks();
            await fetchInvestorTypes();
            await fetchDefinedSectors();
            await fetchDefinedRegions();
        } catch (err) {
            console.log(err);
        }
    };

    // calculate total allocation
    useEffect(() => {
        const totalTargetWeight = assetAllocation?.reduce((sum, item) => {
            return sum + parseFloat(item?.target_weight);
        }, 0);
        setTotalAllocation(totalTargetWeight);
    }, [assetAllocation]);

    // refresh sub sectors based on sector
    useEffect(() => {
        fetchDefinedSubSectors();
    }, [allowedSectors]);

    useEffect(() => {
        if (docid === "new" || docid === undefined) {
            setDocumentEnabled("Y");
            callDetailsFunction();
        } else {
            fetchFund(docid, true);
        }
        // This is called here because there's no fetching of the data
        fetchFeesDetails();
    }, [docid]);


    return (
        <motion.div
            className="am-fund"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1 } }}
            exit={{ opacity: 0, transition: { duration: 1 } }}
        >
            {isLoading ? (
                <div className="no-content">
                    <ScaleLoader
                        color="var(--primary)"
                        height={50}
                        radius={8}
                        width={4}
                    />
                </div>
            ) : (
                <div className="am-fund-main-wrapper">
                    <div className="navbar">
                        <div className="navbar-left">
                            <span className="main-title">{fundData?.fund_name}</span>
                        </div>
                        <div className="navbar-right">
                            <CustomLoadingButton
                                currentTheme={currentTheme}
                                iconPosition="end"
                                borderRadiusType="left"
                                endIcon={<IoIosRefresh />}
                                onClick={async () => await fetchFund(fundDocId)}
                            >
                                {t('refresh')}
                            </CustomLoadingButton>
                            {nextAction !== "None" &&
                                <CustomLoadingButton
                                    currentTheme={currentTheme}
                                    iconPosition="end"
                                    borderRadiusType="none"
                                    endIcon={<MdDragIndicator />}
                                    onClick={() => {
                                        setConfirmationActiontext(`Do you want to ${nextAction} this fund?`);
                                        setConfirmDialogAction(nextAction);
                                        setIsConfirmDialogOpen(true);
                                    }}
                                >
                                    {t(nextAction)}
                                </CustomLoadingButton>}
                            {saveEnabled === "Y" && (
                                <CustomLoadingButton
                                    currentTheme={currentTheme}
                                    iconPosition="end"
                                    borderRadiusType="none"
                                    endIcon={<MdSave />}
                                    onClick={saveRecord}>
                                    {t('save')}
                                </CustomLoadingButton>
                            )}
                            {fundDocId !== "new" && (
                                <CustomLoadingButton
                                    currentTheme={currentTheme}
                                    iconPosition="end"
                                    borderRadiusType="none"
                                    endIcon={<IoDocumentTextSharp />}
                                    onClick={() => setReportsDialogOpen(true)}>
                                    {t('reports')}
                                </CustomLoadingButton>
                            )}
                            <CustomLoadingButton
                                currentTheme={currentTheme}
                                iconPosition="end"
                                borderRadiusType="right"
                                endIcon={<MdClose />}
                                onClick={() => navigate(-1)}>
                                {t('close')}
                            </CustomLoadingButton>
                        </div>
                    </div>
                    <div className="main-content-wrapper">
                        <div className="fund-wrapper">
                            <div className="fund-details">
                                <div className="details-view">
                                    <ExpandableComponent
                                        title={t('details').toUpperCase()}
                                        subtitle={<span className={`status ${fundData?.fund_status}`}>{`${t('status').toUpperCase()} ${fundData?.fund_status}`}</span>}
                                        defaultExpanded={true}
                                    >
                                        <div className="row-details">
                                            <div className="row-left" >
                                                <div className="input-item-with-label">
                                                    <label htmlFor="fund_name"
                                                        className="form-input-label"
                                                        style={{ width: "100px" }}>
                                                        {t('name').toUpperCase()}
                                                    </label>
                                                    <input
                                                        name="fund_name"
                                                        type="text"
                                                        placeholder={t('name').toUpperCase()}
                                                        className="form-input-item"
                                                        style={{ width: "100%" }}
                                                        value={fundData?.fund_name}
                                                        onChange={(e) => handleSetFundData("fund_name", e.target.value)}
                                                        disabled={documentEnabled === "N"}
                                                        onBlur={(e) => {
                                                            if (e.target.value && !fundData?.fund_alias) {
                                                                handleSetFundData("fund_alias", getFirstName(e.target.value));
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                <div style={{ display: "flex", width: "100%", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                                                    <div className="input-item-with-label">
                                                        <label htmlFor="fund_alias"
                                                            className="form-input-label"
                                                            style={{ width: "85px" }}>
                                                            {t('alias').toUpperCase()}
                                                        </label>
                                                        <input
                                                            name="fund_alias"
                                                            type="text"
                                                            placeholder={t('alias').toUpperCase()}
                                                            className="form-input-item"
                                                            style={{ width: "200px" }}
                                                            value={fundData?.fund_alias}
                                                            onChange={(e) => handleSetFundData("fund_alias", e.target.value)}
                                                            disabled={documentEnabled === "N"}
                                                        />
                                                    </div>
                                                    <div className="input-item-with-label">
                                                        <label htmlFor="fund_code"
                                                            className="form-input-label"
                                                            style={{ width: "max-content" }}>
                                                            {t('code').toUpperCase()}
                                                        </label>
                                                        <input
                                                            name="fund_code"
                                                            type="text"
                                                            placeholder={t('code').toUpperCase()}
                                                            className="form-input-item"
                                                            style={{ width: "150px" }}
                                                            value={fundData?.fund_code}
                                                            onChange={(e) => handleSetFundData("fund_code", e.target.value)}
                                                            disabled={fundData?.fund_code}
                                                        />
                                                    </div>
                                                </div>

                                                <div style={{ display: "flex", width: "100%", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                                                    <div className="input-item-with-label">
                                                        <label htmlFor="fund_class_type"
                                                            className="form-input-label"
                                                            style={{ width: "85px" }}>
                                                            {t('class').toUpperCase()}
                                                        </label>
                                                        {documentEnabled === "Y" ?
                                                            <Select
                                                                id="fund_class_type"
                                                                name="fund_class_type"
                                                                menuPortalTarget={document.body}
                                                                styles={{
                                                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                    menuPortal: base => ({
                                                                        ...base,
                                                                        zIndex: 9999,
                                                                    })
                                                                }}
                                                                width="200px"
                                                                value={fundClassTypes.find(option => option.value === fundData?.fund_class_type) || null}
                                                                onChange={selectedOption => handleSetFundData("fund_class_type", selectedOption?.value)}
                                                                options={fundClassTypes}
                                                                isSearchable={true}
                                                                placeholder={t('class')}
                                                                isDisabled={documentEnabled === "N"}
                                                            /> :
                                                            <input
                                                                name="fund_class_type_xx"
                                                                type="text"
                                                                className="form-input-item"
                                                                style={{ width: "200px" }}
                                                                value={fundData?.fund_class_type}
                                                                disabled={true}
                                                            />
                                                        }
                                                    </div>

                                                    <div className="input-item-with-label">
                                                        <label htmlFor="valuation_method"
                                                            className="form-input-label"
                                                            style={{ width: "max-content" }}>
                                                            {t('valuation').toUpperCase()}
                                                        </label>
                                                        <Select
                                                            id="valuation_method"
                                                            name="valuation_method"
                                                            menuPortalTarget={document.body}
                                                            styles={{
                                                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                menuPortal: base => ({
                                                                    ...base,
                                                                    zIndex: 9999,
                                                                })
                                                            }}
                                                            width="150px"
                                                            value={valuationMethods.find(option => option.value === fundData?.valuation_method) || null}
                                                            onChange={selectedOption => handleSetFundData("valuation_method", selectedOption?.value)}
                                                            options={valuationMethods}
                                                            isSearchable={true}
                                                            placeholder={t('valuation')}
                                                            isDisabled={documentEnabled === "N"}
                                                        />
                                                    </div>
                                                </div>

                                                <div style={{ display: "flex", flexDirection: "row", width: "100%", alignItems: "center", justifyContent: "flex-end" }}>
                                                    <div className="input-item-with-label">
                                                        <label htmlFor="nav_per_unit"
                                                            className="form-input-label"
                                                            style={{ width: "max-content" }}>
                                                            {t('initialNavPerUnit').toUpperCase()}
                                                        </label>
                                                        <input
                                                            name="nav_per_unit"
                                                            type="text"
                                                            placeholder="0.00"
                                                            className="form-input-item"
                                                            style={{ width: "150px", textAlign: "right" }}
                                                            value={fundData?.nav_per_unit}
                                                            onChange={(e) => {
                                                                try {
                                                                    handleSetFundData("nav_per_unit", e.target.value);
                                                                } catch (error) {
                                                                    console.log(error);
                                                                }
                                                            }}
                                                            disabled={documentEnabled === "N"}
                                                            onBlur={(e) => {
                                                                try {
                                                                    if (e.target.value) {
                                                                        const strippedValue = e.target.value.replace(/,/g, "");
                                                                        if (isNaN(strippedValue)) {
                                                                            setNotifyDialogTitle("Error!");
                                                                            setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
                                                                            setIsNotifyDialogOpen(true);
                                                                            return;
                                                                        }
                                                                        handleSetFundData("nav_per_unit", formatAmountsToDecimals(strippedValue || 0));
                                                                    }
                                                                } catch (error) {
                                                                    console.log(error)
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div style={{ display: "flex", flexDirection: "row", width: "100%", alignItems: "center", justifyContent: "flex-end" }}>
                                                    <div className="input-item-with-label">
                                                        <label htmlFor="minimum_subscription"
                                                            className="form-input-label"
                                                            style={{ width: "max-content" }}>
                                                            {t('minNavSub').toUpperCase()}
                                                        </label>
                                                        <input
                                                            name="minimum_subscription"
                                                            type="text"
                                                            placeholder="0.00"
                                                            className="form-input-item"
                                                            style={{ width: "150px", textAlign: "right" }}
                                                            value={fundData?.minimum_subscription}
                                                            onChange={(e) => handleSetFundData("minimum_subscription", e.target.value)}
                                                            disabled={documentEnabled === "N"}
                                                            onBlur={(e) => {
                                                                try {
                                                                    if (e.target.value) {
                                                                        const strippedValue = e.target.value.replace(/,/g, "");
                                                                        if (isNaN(strippedValue)) {
                                                                            setNotifyDialogTitle("Error!");
                                                                            setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
                                                                            setIsNotifyDialogOpen(true);
                                                                            return;
                                                                        }
                                                                        handleSetFundData("minimum_subscription", formatAmountsToDecimals(strippedValue || 0));
                                                                    }
                                                                } catch (error) {
                                                                    console.log(error)
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>

                                                <div style={{ display: "flex", width: "100%", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                                                    <div className="input-item-with-label">
                                                        <label htmlFor="investment_horizon"
                                                            className="form-input-label"
                                                            style={{ width: "85px" }}>
                                                            {t('horizon').toUpperCase()}
                                                        </label>
                                                        {documentEnabled === "Y" ?
                                                            <Select
                                                                id="investment_horizon"
                                                                name="investment_horizon"
                                                                menuPortalTarget={document.body}
                                                                styles={{
                                                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                    menuPortal: base => ({
                                                                        ...base,
                                                                        zIndex: 9999,
                                                                    })
                                                                }}
                                                                width="200px"
                                                                value={horizonTypes.find(option => option.value === fundData?.investment_horizon) || null}
                                                                onChange={selectedOption => handleSetFundData("investment_horizon", selectedOption?.value)}
                                                                options={horizonTypes}
                                                                isSearchable={true}
                                                                placeholder={t('horizon')}
                                                                isDisabled={documentEnabled === "N"}
                                                            /> :
                                                            <input
                                                                name="investment_horizon_xx"
                                                                type="text"
                                                                className="form-input-item"
                                                                style={{ width: "200px" }}
                                                                value={fundData?.investment_horizon_xx}
                                                                disabled={true}
                                                            />}
                                                    </div>

                                                    <div className="input-item-with-label">
                                                        <label htmlFor="risk_profile"
                                                            className="form-input-label"
                                                            style={{ width: "max-content" }}>
                                                            {t('riskProfile').toUpperCase()}
                                                        </label>
                                                        <Select
                                                            id="risk_profile"
                                                            name="risk_profile"
                                                            menuPortalTarget={document.body}
                                                            styles={{
                                                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                menuPortal: base => ({
                                                                    ...base,
                                                                    zIndex: 9999,
                                                                })
                                                            }}
                                                            width="150px"
                                                            value={riskProfiles.find(option => option.value === fundData?.risk_profile) || null}
                                                            onChange={selectedOption => handleSetFundData("risk_profile", selectedOption?.value)}
                                                            options={riskProfiles}
                                                            isSearchable={true}
                                                            placeholder={t('riskProfile')}
                                                            isDisabled={documentEnabled === "N"}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row-right">
                                                <div className="input-item-with-label">
                                                    <label htmlFor="base_currency"
                                                        className="form-input-label"
                                                        style={{ width: "max-content" }}>
                                                        {t('currency').toUpperCase()}
                                                    </label>
                                                    <input
                                                        name="base_currency"
                                                        type="text"
                                                        placeholder={t('currency').toUpperCase()}
                                                        className="form-input-item"
                                                        style={{ width: "150px" }}
                                                        value={fundData?.base_currency}
                                                        onChange={(e) => handleSetFundData("base_currency", e.target.value)}
                                                        disabled={true}
                                                    />
                                                </div>
                                                <div className="input-item-with-label">
                                                    <label htmlFor="fund_type"
                                                        className="form-input-label"
                                                        style={{ width: "max-content" }}>
                                                        {t('type').toUpperCase()}
                                                    </label>
                                                    {documentEnabled === "Y" ?
                                                        <Select
                                                            id="fund_type"
                                                            name="fund_type"
                                                            menuPortalTarget={document.body}
                                                            styles={{
                                                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                menuPortal: base => ({
                                                                    ...base,
                                                                    zIndex: 9999,
                                                                })
                                                            }}
                                                            width="150px"
                                                            value={fundTypes.find(option => option.value === fundData?.fund_type) || null}
                                                            onChange={selectedOption => handleSetFundData("fund_type", selectedOption?.value)}
                                                            options={fundTypes}
                                                            isSearchable={true}
                                                            placeholder={t('types')}
                                                        /> :
                                                        <input
                                                            name="fund_type_xx"
                                                            type="text"
                                                            className="form-input-item"
                                                            style={{ width: "150px" }}
                                                            value={fundData?.fund_type_xx}
                                                            disabled={true}
                                                        />}
                                                </div>
                                                <div className="input-item-with-label">
                                                    <label htmlFor="distribution_policy"
                                                        className="form-input-label"
                                                        style={{ width: "max-content" }}>
                                                        {t('distribution').toUpperCase()}
                                                    </label>
                                                    <Select
                                                        id="distribution_policy"
                                                        name="distribution_policy"
                                                        menuPortalTarget={document.body}
                                                        styles={{
                                                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                            menuPortal: base => ({
                                                                ...base,
                                                                zIndex: 9999,
                                                            })
                                                        }}
                                                        width="150px"
                                                        value={distributionPolicies.find(option => option.value === fundData?.distribution_policy) || null}
                                                        onChange={selectedOption => handleSetFundData("distribution_policy", selectedOption?.value)}
                                                        options={distributionPolicies}
                                                        isSearchable={true}
                                                        placeholder={t('distribution')}
                                                        isDisabled={documentEnabled === "N"}
                                                    />
                                                </div>
                                                <div className="input-item-with-label" >
                                                    <label htmlFor="launch_date" className="form-input-label">
                                                        {t('launchDate').toUpperCase()}
                                                    </label>
                                                    <input
                                                        name="launch_date"
                                                        type="date"
                                                        placeholder={t('launchDate').toUpperCase()}
                                                        className="form-input-item"
                                                        style={{ width: "150px" }}
                                                        value={fundData?.launch_date}
                                                        onChange={(e) => {
                                                            try {
                                                                const formattedDate = moment(e.target.value).format("YYYY-MM-DD");
                                                                handleSetFundData("launch_date", formattedDate);
                                                            } catch (error) {
                                                                console.log(error);
                                                            }
                                                        }}
                                                        disabled={documentEnabled === "N"}
                                                    />
                                                </div>
                                                <div className="input-item-with-label">
                                                    <label htmlFor="aum_cap"
                                                        className="form-input-label"
                                                        style={{ width: "max-content" }}>
                                                        {t('aumCap').toUpperCase()}
                                                    </label>
                                                    <input
                                                        name="aum_cap"
                                                        type="text"
                                                        placeholder="0.00"
                                                        className="form-input-item"
                                                        style={{ width: "150px", textAlign: "right" }}
                                                        value={fundData?.aum_cap}
                                                        onChange={(e) => handleSetFundData("aum_cap", e.target.value)}
                                                        disabled={documentEnabled === "N"}
                                                        onBlur={(e) => {
                                                            try {
                                                                if (e.target.value) {
                                                                    const strippedValue = e.target.value.replace(/,/g, "");
                                                                    if (isNaN(strippedValue)) {
                                                                        setNotifyDialogTitle("Error!");
                                                                        setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
                                                                        setIsNotifyDialogOpen(true);
                                                                        return;
                                                                    }
                                                                    handleSetFundData("aum_cap", formatAmountsToDecimals(strippedValue || 0));
                                                                }
                                                            } catch (error) {
                                                                console.log(error)
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                <div className="input-item-with-label">
                                                    <label htmlFor="expected_aum"
                                                        className="form-input-label"
                                                        style={{ width: "max-content" }}>
                                                        {t('expectedAum').toUpperCase()}
                                                    </label>
                                                    <input
                                                        name="expected_aum"
                                                        type="text"
                                                        placeholder="0.00"
                                                        className="form-input-item"
                                                        style={{ width: "150px", textAlign: "right" }}
                                                        value={fundData?.expected_aum}
                                                        onChange={(e) => handleSetFundData("expected_aum", e.target.value)}
                                                        disabled={documentEnabled === "N"}
                                                        onBlur={(e) => {
                                                            try {
                                                                if (e.target.value) {
                                                                    const strippedValue = e.target.value.replace(/,/g, "");
                                                                    if (isNaN(strippedValue)) {
                                                                        setNotifyDialogTitle("Error!");
                                                                        setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
                                                                        setIsNotifyDialogOpen(true);
                                                                        return;
                                                                    }
                                                                    handleSetFundData("expected_aum", formatAmountsToDecimals(strippedValue || 0));
                                                                }
                                                            } catch (error) {
                                                                console.log(error)
                                                            }
                                                        }}
                                                    />
                                                </div>

                                            </div>
                                        </div>
                                        <div style={{ display: "flex", width: "100%", marginTop: "5px", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                                            {documentEnabled === "Y" ?
                                                <div className="input-item-with-label" style={{ width: "100%" }}>
                                                    <label htmlFor="fund_objective"
                                                        className="form-input-label"
                                                        style={{ width: "95px", alignSelf: "flex-start" }}>
                                                        {t('objective').toUpperCase()}
                                                    </label>
                                                    <textarea
                                                        name="fund_objective"
                                                        type="text"
                                                        rows={3}
                                                        placeholder={t('objective').toUpperCase()}
                                                        className="form-input-item"
                                                        style={{ width: "100%" }}
                                                        value={fundData?.fund_objective}
                                                        onChange={(e) => handleSetFundData("fund_objective", e.target.value)}
                                                        disabled={documentEnabled === "N"}
                                                    />
                                                </div> :
                                                <span style={{ paddingLeft: "90px" }}>  <span className="sub-title">{t('objective').toUpperCase()} : <p>{fundData?.fund_objective}</p> </span></span>}
                                        </div>
                                        <div style={{ display: "flex", marginTop: "5px", width: "100%", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                                            {documentEnabled === "Y" ?
                                                <div className="input-item-with-label" style={{ width: "100%" }}>
                                                    <label htmlFor="investment_strategy"
                                                        className="form-input-label"
                                                        style={{ width: "95px", alignSelf: "flex-start" }}>
                                                        {t('strategy').toUpperCase()}
                                                    </label>
                                                    <textarea
                                                        name="investment_strategy"
                                                        type="text"
                                                        rows={3}
                                                        placeholder={t('strategy').toUpperCase()}
                                                        className="form-input-item"
                                                        style={{ width: "100%" }}
                                                        value={fundData?.investment_strategy}
                                                        onChange={(e) => {
                                                            try {
                                                                handleSetFundData("investment_strategy", e.target.value);
                                                            } catch (error) {
                                                                console.log(error);
                                                            }
                                                        }}
                                                        disabled={documentEnabled === "N"}
                                                    />
                                                </div> :
                                                <span style={{ paddingLeft: "90px" }}>  <span className="sub-title">{t('strategy').toUpperCase()} : <p>{fundData?.investment_strategy}</p> </span></span>}
                                        </div>
                                        <hr className="separator-h" style={{ margin: "3px 0px" }} />
                                        <div style={{ display: "flex", flexDirection: "row", gap: "5px", alignItems: "center", justifyContent: "space-between" }}>
                                            <span className="sub-title">{t('benchmark').toUpperCase()}</span>
                                            <div style={{ display: "flex", flexDirection: "row", gap: "5px", alignItems: "center" }}>
                                                <span className="sub-title">{t('targetType').toUpperCase()}</span>
                                                <RadioGroup
                                                    row
                                                    value={fundData?.benchmark_target_type}
                                                    onChange={handleBenchmarkChange}
                                                    name="benchmark-type"
                                                >
                                                    {benchmarkTypes.map((bm) => (
                                                        <FormControlLabel
                                                            key={bm}
                                                            value={bm}
                                                            control={<Radio disabled={documentEnabled === "N"} />}
                                                            label={bm}
                                                        />
                                                    ))}
                                                </RadioGroup>
                                            </div>
                                        </div>
                                        <div className="row-details">
                                            <div className="row-left">
                                                <div className="input-item-with-label">
                                                    <label htmlFor="fund_name"
                                                        className="form-input-label"
                                                        style={{ width: "100px" }}>
                                                        {t('ref').toUpperCase()}
                                                    </label>
                                                    {documentEnabled === "Y" ?
                                                        <Select
                                                            id="benchmark_code"
                                                            name="benchmark_code"
                                                            menuPortalTarget={document.body}
                                                            styles={{
                                                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                menuPortal: base => ({
                                                                    ...base,
                                                                    zIndex: 9999,
                                                                })
                                                            }}
                                                            width="100%"
                                                            value={benchmarks.find(option => option.value === fundData?.benchmark_code) || null}
                                                            onChange={selectedOption => {
                                                                try {
                                                                    handleSetFundData("benchmark_code", selectedOption?.value)
                                                                    handleSetFundData("benchmark_docid", selectedOption?.docid)
                                                                } catch (error) {
                                                                    console.log(error);
                                                                }
                                                            }}
                                                            options={benchmarks}
                                                            isSearchable={true}
                                                            placeholder={t('benchmarks')}
                                                            isDisabled={documentEnabled === "N"}
                                                        /> :
                                                        <input
                                                            name="benchmark_name_xx"
                                                            type="text"
                                                            className="form-input-item"
                                                            style={{ width: "100%" }}
                                                            value={fundData?.benchmark_name_xx}
                                                            disabled={true}
                                                        />}
                                                </div>
                                            </div>
                                            <div className="row-right">
                                                <div className="input-item-with-label">
                                                    <label htmlFor="benchmark_target"
                                                        className="form-input-label"
                                                        style={{ width: "max-content" }}>
                                                        {t('target').toUpperCase()} [%]
                                                    </label>
                                                    <input
                                                        name="benchmark_target"
                                                        type="text"
                                                        placeholder="0.00"
                                                        className="form-input-item"
                                                        style={{ width: "150px", textAlign: "right" }}
                                                        value={fundData?.benchmark_target}
                                                        onChange={(e) => handleSetFundData("benchmark_target", e.target.value)}
                                                        disabled={documentEnabled === "N"}
                                                        onBlur={(e) => {
                                                            try {
                                                                if (e.target.value) {
                                                                    const strippedValue = e.target.value.replace(/,/g, "");
                                                                    if (isNaN(strippedValue)) {
                                                                        setNotifyDialogTitle("Error!");
                                                                        setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
                                                                        setIsNotifyDialogOpen(true);
                                                                        return;
                                                                    }
                                                                    handleSetFundData("benchmark_target", formatAmountsToDecimals(strippedValue || 0));
                                                                }
                                                            } catch (error) {
                                                                console.log(error)
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "column", gap: "5px", paddingLeft: "90px" }}>
                                            <span className="sub-title">{t('benchmark')} : <span>{t('benchmarkDesc')}</span></span>
                                            <span className="sub-title">{t('target')} : <span>{t('benchmarkTargetDesc')}</span></span>
                                            <span className="sub-title">{t('targetType')} {t('note')} :</span>
                                            <span className="sub-title">{t('absolute')} : <span>{t('targetAbsoluteDesc')}</span></span>
                                            <span className="sub-title">{t('relative')} : <span>{t('targetRelativeDesc')}</span></span>
                                        </div>
                                        <hr className="separator-h" style={{ margin: "3px 0px" }} />
                                        <span className="sub-title">{t('custodian').toUpperCase()}</span>
                                        {selectedCustodian &&
                                            <motion.div
                                                className="entity-details-container"
                                                initial={{ opacity: 0 }}
                                                animate={{ opacity: 1, transition: { duration: 1 } }}
                                                exit={{ opacity: 0, transition: { duration: 1 } }}>
                                                <div className="entity-details-wrapper">
                                                    <div className="entity-details-left">
                                                        {selectedCustodian?.ent_photo_url ?
                                                            <img src={selectedCustodian?.ent_photo_url} alt="" className="img" /> : <CiImageOn style={{ width: "60px", height: "60px" }} />}
                                                    </div>
                                                    <div className="entity-details-right">
                                                        <div className="name-row">
                                                            {documentEnabled === "Y" ?
                                                                <div className="input-item-with-label">
                                                                    <AsyncSelect
                                                                        id="fund_custodian_ent"
                                                                        name="fund_custodian_ent"
                                                                        menuPortalTarget={document.body}
                                                                        styles={{
                                                                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                            menuPortal: base => ({
                                                                                ...base,
                                                                                zIndex: 9999,
                                                                            })
                                                                        }}
                                                                        width="400px"
                                                                        isClearable
                                                                        value={selectedCustodian}
                                                                        onChange={(selectedOption) => setSelectedCustodian(selectedOption)}
                                                                        loadOptions={(inputValue, callback) => fetchClientsBySearch(inputValue, callback, ["Corporate"])}
                                                                        isSearchable={true}
                                                                        placeholder={t('custodian').toUpperCase()}
                                                                        noOptionsMessage={() => "Type Minimum 3 Letter to Search"}
                                                                    />
                                                                </div>
                                                                : <span className="main-title"> {selectedCustodian?.ent_name}</span>}
                                                            <span className={`status ${selectedCustodian?.ent_status}`}>{`${t('custodian').toUpperCase()} ${t('status').toUpperCase()} ${selectedCustodian?.ent_status}`}</span>
                                                        </div>
                                                        <div className="email-phone-row" style={{ display: "flex", alignCenter: "center", flexDirection: "row", width: "100%" }}>
                                                            <span className="email-phone-details" style={{ display: "flex", alignCenter: "center", flexDirection: "row", cursor: "pointer", flex: "1.8" }}>
                                                                <MdEmail className="icon" /> <span className="sub-title">{selectedCustodian?.ent_email || t('unspecified')}</span>
                                                            </span>
                                                            <span className="email-phone-details" style={{ display: "flex", alignCenter: "center", flexDirection: "row", flex: "1" }}>
                                                                <MdPhone className="icon" /> <span className="sub-title">{selectedCustodian?.ent_phone_no || t('unspecified')}</span>
                                                            </span>
                                                            <span className="email-phone-details" style={{ display: "flex", alignCenter: "center", flexDirection: "row", flex: "1" }}>
                                                                <TbCertificate className="icon" /> <span className="sub-title">{selectedCustodian?.aent_name_xx || t('unspecified')}</span>
                                                            </span>
                                                            <span className="email-phone-details"
                                                                style={{ display: "flex", alignCenter: "center", flexDirection: "row", cursor: "pointer", flex: "1" }}
                                                                onClick={() => navigate(`/entity/${selectedCustodian?.ent_docid}`)}>
                                                                <MdOutlineNumbers className="icon" /> <span className="sub-title">{selectedCustodian?.ent_code}</span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </motion.div>}
                                    </ExpandableComponent>
                                </div>

                                <ExpandableComponent
                                    title={t('controls').toUpperCase()}
                                    subtitle=""
                                    onSubtitleClick={() => { }}
                                    defaultExpanded={false}
                                >
                                    {/* start of eligible investors and sectors */}
                                    <div className="controls-wrapper">
                                        <div className="controls-details">
                                            <div className="controls-details-left">
                                                {/* start of eligible investors */}
                                                <div style={{ display: "flex", flexDirection: "row", gap: "5px", alignItems: "center", justifyContent: "space-between" }}>
                                                    <span className="sub-title">{t('eligibleInvestors').toUpperCase()}</span>
                                                    <div style={{ display: "flex", flexDirection: "row", gap: "5px", alignItems: "center" }}>
                                                        {documentEnabled === "Y" ?
                                                            <div className="input-item-with-label" style={{ width: "100%", gap: "5px" }}>
                                                                <Select
                                                                    id="eligible_investors"
                                                                    name="eligible_investors"
                                                                    menuPortalTarget={document.body}
                                                                    styles={{
                                                                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                        menuPortal: base => ({
                                                                            ...base,
                                                                            zIndex: 9999,
                                                                        })
                                                                    }}
                                                                    width="200px"
                                                                    value={selectedInvestor}
                                                                    onChange={(selectedOption) => setSelectedInvestor(selectedOption)}
                                                                    options={investorTypes}
                                                                    isSearchable={true}
                                                                    placeholder={t('investor')}
                                                                />
                                                                <CircularButton
                                                                    currentTheme={currentTheme}
                                                                    onClick={async (e) => {
                                                                        try {
                                                                            if (!selectedInvestor) {
                                                                                setNotifyDialogTitle("Note!");
                                                                                setNotifyDialogText(`Please select invetor add!`);
                                                                                setIsNotifyDialogOpen(true);
                                                                                return;
                                                                            }
                                                                            const res = await newRequest.post("/fund/addEligibleInvestor",
                                                                                {
                                                                                    fund_docid: fundDocId,
                                                                                    investor_type: selectedInvestor?.value
                                                                                });
                                                                            if (res.data?.msg === "added") {
                                                                                setEligibleInvestors((prevData) => [...prevData, res.data?.doc]);
                                                                                setSelectedInvestor(null);
                                                                                showToast("Added!", "success");
                                                                            } else if (res.data?.msg === "exists") {
                                                                                showToast(`${selectedInvestor?.label} is already added to this fund`, "warning");
                                                                            } else {
                                                                                showToast("Error adding investor!", "error");
                                                                            }
                                                                        } catch (error) {
                                                                            console.log(error);
                                                                        }
                                                                    }}
                                                                    icon={<MdAdd color="green" />} width={"35px"} height={"35px"} />
                                                            </div>
                                                            :
                                                            <span />}
                                                    </div>
                                                </div>
                                                <div className="list-details-wrapper" style={{ marginTop: "10px" }}>
                                                    {eligibleInvestors.length > 0 && (
                                                        <>
                                                            {eligibleInvestors?.map((row, index) => (
                                                                <div key={row} className="single-item">
                                                                    <span className="sub-title">
                                                                        {index + 1}.
                                                                    </span>
                                                                    <span className="sub-title">{row}</span>
                                                                    {documentEnabled === "Y" && (
                                                                        <CircularButton
                                                                            currentTheme={currentTheme}
                                                                            onClick={async (e) => {
                                                                                try {
                                                                                    const res = await newRequest.post("/fund/removeEligibleInvestor",
                                                                                        {
                                                                                            fund_docid: fundDocId,
                                                                                            investor_type: row
                                                                                        });

                                                                                    if (res.data?.msg === "removed") {
                                                                                        setEligibleInvestors((prevData) => prevData.filter(doc => doc !== row));
                                                                                        showToast("Removed!", "success");
                                                                                    } else {
                                                                                        showToast("Error deleting report!", "error");
                                                                                    }
                                                                                } catch (error) {
                                                                                    console.log(error);
                                                                                }
                                                                            }}
                                                                            color="#E53935" icon={<MdDelete/>} width={"25px"} height={"25px"} padding={"3px"} />
                                                                    )}
                                                                </div>
                                                            ))}
                                                        </>
                                                    )}
                                                </div>
                                                {/* end of eligible investors */}
                                            </div>
                                            <div className="controls-details-right">
                                                {/* start of sectors */}
                                                <div style={{ display: "flex", flexDirection: "row", gap: "5px", alignItems: "center", justifyContent: "space-between" }}>
                                                    <span className="sub-title">{t('sectors').toUpperCase()}</span>
                                                    <div style={{ display: "flex", flexDirection: "row", gap: "5px", alignItems: "center" }}>
                                                        {documentEnabled === "Y" ?
                                                            <div className="input-item-with-label" style={{ width: "100%", gap: "5px" }}>
                                                                <Select
                                                                    id="allowed_sectors"
                                                                    name="allowed_sectors"
                                                                    menuPortalTarget={document.body}
                                                                    styles={{
                                                                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                        menuPortal: base => ({
                                                                            ...base,
                                                                            zIndex: 9999,
                                                                        })
                                                                    }}
                                                                    width="200px"
                                                                    value={selectedSector}
                                                                    onChange={(selectedOption) => setSelectedSector(selectedOption)}
                                                                    options={definedSectors}
                                                                    isSearchable={true}
                                                                    placeholder={t('sector')}
                                                                />
                                                                <CircularButton
                                                                    currentTheme={currentTheme}
                                                                    onClick={async (e) => {
                                                                        try {
                                                                            if (!selectedSector) {
                                                                                setNotifyDialogTitle("Note!");
                                                                                setNotifyDialogText(`Please select sector add!`);
                                                                                setIsNotifyDialogOpen(true);
                                                                                return;
                                                                            }
                                                                            const res = await newRequest.post("/fund/addSector",
                                                                                {
                                                                                    fund_docid: fundDocId,
                                                                                    sector_code: selectedSector?.value
                                                                                });
                                                                            if (res.data?.msg === "added") {
                                                                                setAllowedSectors((prevData) => [...prevData, res.data?.doc]);
                                                                                setSelectedSector(null);
                                                                                showToast("Added!", "success");
                                                                            } else if (res.data?.msg === "exists") {
                                                                                showToast(`${selectedSector?.label} is already added to this fund`, "warning");
                                                                            } else {
                                                                                showToast("Error adding sector!", "error");
                                                                            }
                                                                        } catch (error) {
                                                                            console.log(error);
                                                                        }
                                                                    }}
                                                                    icon={<MdAdd color="green" />} width={"35px"} height={"35px"} />
                                                            </div>
                                                            :
                                                            <span />}
                                                    </div>
                                                </div>
                                                <div className="list-details-wrapper" style={{ marginTop: "10px" }}>
                                                    {allowedSectors.length > 0 && (
                                                        <>
                                                            {allowedSectors?.map((row, index) => (
                                                                <div key={row?.sector} className="single-item">
                                                                    <span className="sub-title">
                                                                        {index + 1}.
                                                                    </span>
                                                                    <span className="sub-title">{row?.sector_name_xx}</span>
                                                                    {documentEnabled === "Y" && (
                                                                        <CircularButton
                                                                            currentTheme={currentTheme}
                                                                            onClick={async (e) => {
                                                                                try {
                                                                                    const res = await newRequest.post("/fund/removeSector",
                                                                                        {
                                                                                            fund_docid: fundDocId,
                                                                                            sector_code: row?.sector
                                                                                        });

                                                                                    if (res.data?.msg === "removed") {
                                                                                        setAllowedSectors((prevData) =>
                                                                                            prevData.filter(doc => doc?.sector !== row?.sector)
                                                                                        );

                                                                                        showToast("Removed!", "success");
                                                                                    } else {
                                                                                        showToast("Error deleting report!", "error");
                                                                                    }
                                                                                } catch (error) {
                                                                                    console.log(error);
                                                                                }
                                                                            }}
                                                                            color="#E53935" icon={<MdDelete/>} width={"25px"} height={"25px"} padding={"3px"} />
                                                                    )}
                                                                </div>
                                                            ))}
                                                        </>
                                                    )}
                                                </div>

                                                {/* end of sectors */}
                                            </div>
                                        </div>
                                    </div>
                                    {/* end of eligible investors and sectors */}
                                    <hr className="separator-h" />
                                    {/* start of regions and sub sectors */}
                                    <div className="controls-wrapper">
                                        <div className="controls-details">
                                            <div className="controls-details-left">
                                                {/* start of regions */}
                                                <div style={{ display: "flex", flexDirection: "row", gap: "5px", alignItems: "center", justifyContent: "space-between" }}>
                                                    <span className="sub-title">{t('regions').toUpperCase()}</span>
                                                    <div style={{ display: "flex", flexDirection: "row", gap: "5px", alignItems: "center" }}>
                                                        {documentEnabled === "Y" ?
                                                            <div className="input-item-with-label" style={{ width: "100%", gap: "5px" }}>
                                                                <Select
                                                                    id="allowed_regions"
                                                                    name="allowed_regions"
                                                                    menuPortalTarget={document.body}
                                                                    styles={{
                                                                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                        menuPortal: base => ({
                                                                            ...base,
                                                                            zIndex: 9999,
                                                                        })
                                                                    }}
                                                                    width="200px"
                                                                    value={selectedRegion}
                                                                    onChange={(selectedOption) => {
                                                                        try {
                                                                            setSelectedRegion(selectedOption);
                                                                        } catch (error) {
                                                                            console.log(error);
                                                                        }
                                                                    }}
                                                                    options={definedRegions}
                                                                    isSearchable={true}
                                                                    placeholder={t('region')}
                                                                />
                                                                <CircularButton
                                                                    currentTheme={currentTheme}
                                                                    onClick={async (e) => {
                                                                        try {
                                                                            if (!selectedRegion) {
                                                                                setNotifyDialogTitle("Note!");
                                                                                setNotifyDialogText(`Please select region add!`);
                                                                                setIsNotifyDialogOpen(true);
                                                                                return;
                                                                            }
                                                                            const res = await newRequest.post("/fund/addRegion",
                                                                                {
                                                                                    fund_docid: fundDocId,
                                                                                    region_code: selectedRegion?.value
                                                                                });
                                                                            if (res.data?.msg === "added") {
                                                                                setAllowedRegions((prevData) => [...prevData, res.data?.doc]);
                                                                                setSelectedRegion(null);
                                                                                showToast("Added!", "success");
                                                                            } else if (res.data?.msg === "exists") {
                                                                                showToast(`${selectedRegion?.label} is already added to this fund`, "warning");
                                                                            } else {
                                                                                showToast("Error adding region!", "error");
                                                                            }
                                                                        } catch (error) {
                                                                            console.log(error);
                                                                        }
                                                                    }}
                                                                    icon={<MdAdd color="green" />} width={"35px"} height={"35px"} />
                                                            </div>
                                                            :
                                                            <span />}
                                                    </div>
                                                </div>
                                                <div className="list-details-wrapper" style={{ marginTop: "10px" }}>
                                                    {allowedRegions.length > 0 && (
                                                        <>
                                                            {allowedRegions?.map((row, index) => (
                                                                <div key={row?.region} className="single-item">
                                                                    <span className="sub-title"> {index + 1}.</span>
                                                                    <span className="sub-title">{row?.region_name_xx}</span>
                                                                    {documentEnabled === "Y" && (
                                                                        <CircularButton
                                                                            currentTheme={currentTheme}
                                                                            onClick={async (e) => {
                                                                                try {
                                                                                    const res = await newRequest.post("/fund/removeRegion",
                                                                                        {
                                                                                            fund_docid: fundDocId,
                                                                                            region_code: row?.region
                                                                                        });

                                                                                    if (res.data?.msg === "removed") {
                                                                                        setAllowedRegions((prevData) =>
                                                                                            prevData.filter(doc => doc?.region !== row?.region)
                                                                                        );

                                                                                        showToast("Removed!", "success");
                                                                                    } else {
                                                                                        showToast("Error deleting report!", "error");
                                                                                    }
                                                                                } catch (error) {
                                                                                    console.log(error);
                                                                                }
                                                                            }}
                                                                            color="#E53935" icon={<MdDelete/>} width={"25px"} height={"25px"} padding={"3px"} />
                                                                    )}
                                                                </div>
                                                            ))}
                                                        </>
                                                    )}
                                                </div>
                                                {/* end of eligible investors */}
                                            </div>

                                            <div className="controls-details-right">
                                                {/* start of sub sectors */}
                                                <div style={{ display: "flex", flexDirection: "row", gap: "5px", alignItems: "center", justifyContent: "space-between" }}>
                                                    <span className="sub-title">{t('subSectors').toUpperCase()}</span>
                                                    <div style={{ display: "flex", flexDirection: "row", gap: "5px", alignItems: "center" }}>
                                                        {documentEnabled === "Y" ?
                                                            <div className="input-item-with-label" style={{ width: "100%", gap: "5px" }}>
                                                                <Select
                                                                    id="allowed_sub_sectors"
                                                                    name="allowed_sub_sectors"
                                                                    menuPortalTarget={document.body}
                                                                    styles={{
                                                                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                        menuPortal: base => ({
                                                                            ...base,
                                                                            zIndex: 9999,
                                                                        })
                                                                    }}
                                                                    width="200px"
                                                                    value={selectedSubSector}
                                                                    onChange={(selectedOption) => {
                                                                        try {
                                                                            setSelectedSubSector(selectedOption);
                                                                        } catch (error) {
                                                                            console.log(error);
                                                                        }
                                                                    }}
                                                                    options={definedSubSectors}
                                                                    isSearchable={true}
                                                                    placeholder={t('subSector')}
                                                                />
                                                                <CircularButton
                                                                    currentTheme={currentTheme}
                                                                    onClick={async (e) => {
                                                                        try {
                                                                            if (!selectedSubSector) {
                                                                                setNotifyDialogTitle("Note!");
                                                                                setNotifyDialogText(`Please select sub sector add!`);
                                                                                setIsNotifyDialogOpen(true);
                                                                                return;
                                                                            }
                                                                            const res = await newRequest.post("/fund/addSubSector",
                                                                                {
                                                                                    fund_docid: fundDocId,
                                                                                    sub_sector_code: selectedSubSector?.value
                                                                                });
                                                                            if (res.data?.msg === "added") {
                                                                                setAllowedSubSectors((prevData) => [...prevData, res.data?.doc]);
                                                                                setSelectedSubSector(null);
                                                                                showToast("Added!", "success");
                                                                            } else if (res.data?.msg === "exists") {
                                                                                showToast(`${selectedSubSector?.label} is already added to this fund`, "warning");
                                                                            } else {
                                                                                showToast("Error adding sector!", "error");
                                                                            }
                                                                        } catch (error) {
                                                                            console.log(error);
                                                                        }
                                                                    }}
                                                                    icon={<MdAdd color="green" />} width={"35px"} height={"35px"} />
                                                            </div>
                                                            :
                                                            <span />}
                                                    </div>
                                                </div>
                                                <div className="list-details-wrapper" style={{ marginTop: "10px" }}>
                                                    {allowedSubSectors.length > 0 && (
                                                        <>
                                                            {allowedSubSectors?.map((row, index) => (
                                                                <div key={row?.sector} className="single-item">
                                                                    <span className="sub-title"> {index + 1}.</span>
                                                                    <span className="sub-title">{row?.sub_sector_name_xx}</span>
                                                                    {documentEnabled === "Y" && (
                                                                        <CircularButton
                                                                            currentTheme={currentTheme}
                                                                            onClick={async (e) => {
                                                                                try {
                                                                                    const res = await newRequest.post("/fund/removeSubSector",
                                                                                        {
                                                                                            fund_docid: fundDocId,
                                                                                            sub_sector_code: row?.sub_sector
                                                                                        });

                                                                                    if (res.data?.msg === "removed") {
                                                                                        setAllowedSubSectors((prevData) =>
                                                                                            prevData.filter(doc => doc?.sub_sector !== row?.sub_sector)
                                                                                        );

                                                                                        showToast("Removed!", "success");
                                                                                    } else {
                                                                                        showToast("Error deleting report!", "error");
                                                                                    }
                                                                                } catch (error) {
                                                                                    console.log(error);
                                                                                }
                                                                            }}
                                                                            color="#E53935" icon={<MdDelete/>} width={"25px"} height={"25px"} padding={"3px"} />
                                                                    )}
                                                                </div>
                                                            ))}
                                                        </>
                                                    )}
                                                </div>
                                                {/* end of sub sectors */}
                                            </div>
                                        </div>
                                    </div>
                                    {/* end of regions and sub sectors */}
                                </ExpandableComponent>
                                <ExpandableComponent
                                    title={t('additionalInformation').toUpperCase()}
                                    subtitle=""
                                    onSubtitleClick={() => { }}
                                    defaultExpanded={false}
                                >
                                    <div style={{ display: "flex", flexDirection: "row", width: "100%", paddingLeft: "10px", alignItems: "center", justifyContent: "space-between" }}>
                                        <span className="sub-title">{t('trustee').toUpperCase()}</span>
                                        <span />
                                    </div>
                                    {selectedTrustee &&
                                        <motion.div
                                            className="entity-details-container"
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1, transition: { duration: 1 } }}
                                            exit={{ opacity: 0, transition: { duration: 1 } }}>
                                            <div className="entity-details-wrapper">
                                                <div className="entity-details-left">
                                                    {selectedTrustee?.ent_photo_url ?
                                                        <img src={selectedTrustee?.ent_photo_url} alt="" className="img" /> : <CiImageOn style={{ width: "60px", height: "60px" }} />}
                                                </div>
                                                <div className="entity-details-right">
                                                    <div className="name-row">
                                                        {documentEnabled === "Y" ?
                                                            <div className="input-item-with-label">
                                                                <AsyncSelect
                                                                    id="fund_trustee_ent"
                                                                    name="fund_trustee_ent"
                                                                    menuPortalTarget={document.body}
                                                                    styles={{
                                                                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                        menuPortal: base => ({
                                                                            ...base,
                                                                            zIndex: 9999,
                                                                        })
                                                                    }}
                                                                    width="400px"
                                                                    isClearable
                                                                    value={selectedTrustee}
                                                                    onChange={(selectedOption) => setSelectedTrustee(selectedOption)}
                                                                    loadOptions={(inputValue, callback) => fetchClientsBySearch(inputValue, callback, ["Corporate"])}
                                                                    isSearchable={true}
                                                                    placeholder={t('trustee').toUpperCase()}
                                                                    noOptionsMessage={() => "Type Minimum 3 Letter to Search"}
                                                                />
                                                            </div>
                                                            : <span className="main-title"> {selectedTrustee?.ent_name}</span>}
                                                        <span className={`status ${selectedTrustee?.ent_status}`}>{`${t('trustee').toUpperCase()} ${t('status').toUpperCase()} ${selectedTrustee?.ent_status || ''}`}</span>
                                                    </div>
                                                    <div className="email-phone-row" style={{ display: "flex", alignCenter: "center", flexDirection: "row", width: "100%" }}>
                                                        <span className="email-phone-details" style={{ display: "flex", alignCenter: "center", flexDirection: "row", cursor: "pointer", flex: "1.8" }}>
                                                            <MdEmail className="icon" /> <span className="sub-title">{selectedTrustee?.ent_email || t('unspecified')}</span>
                                                        </span>
                                                        <span className="email-phone-details" style={{ display: "flex", alignCenter: "center", flexDirection: "row", flex: "1" }}>
                                                            <MdPhone className="icon" /> <span className="sub-title">{selectedTrustee?.ent_phone_no || t('unspecified')}</span>
                                                        </span>
                                                        <span className="email-phone-details" style={{ display: "flex", alignCenter: "center", flexDirection: "row", flex: "1" }}>
                                                            <TbCertificate className="icon" /> <span className="sub-title">{selectedTrustee?.aent_name_xx || t('unspecified')}</span>
                                                        </span>
                                                        <span className="email-phone-details"
                                                            style={{ display: "flex", alignCenter: "center", flexDirection: "row", cursor: "pointer", flex: "1" }}
                                                            onClick={() => {
                                                                try {
                                                                    navigate(`/entity/${selectedTrustee?.ent_docid}`);
                                                                } catch (error) {
                                                                    console.log(error)
                                                                }
                                                            }}>
                                                            <MdOutlineNumbers className="icon" /> <span className="sub-title">{selectedTrustee?.ent_code}</span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </motion.div>}
                                    <hr className="separator-h" style={{ margin: "3px 0px" }} />
                                    <div style={{ display: "flex", flexDirection: "row", width: "100%", paddingLeft: "10px", alignItems: "center", justifyContent: "space-between" }}>
                                        <span className="sub-title">{t('auditor').toUpperCase()}</span>
                                        <span />
                                    </div>
                                    {selectedAuditor &&
                                        <motion.div
                                            className="entity-details-container"
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1, transition: { duration: 1 } }}
                                            exit={{ opacity: 0, transition: { duration: 1 } }}>
                                            <div className="entity-details-wrapper">
                                                <div className="entity-details-left">
                                                    {selectedAuditor?.ent_photo_url ?
                                                        <img src={selectedAuditor?.ent_photo_url} alt="" className="img" /> : <CiImageOn style={{ width: "60px", height: "60px" }} />}
                                                </div>
                                                <div className="entity-details-right">
                                                    <div className="name-row">
                                                        {documentEnabled === "Y" ?
                                                            <div className="input-item-with-label">
                                                                <AsyncSelect
                                                                    id="fund_auditor_ent"
                                                                    name="fund_auditor_ent"
                                                                    menuPortalTarget={document.body}
                                                                    styles={{
                                                                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                        menuPortal: base => ({
                                                                            ...base,
                                                                            zIndex: 9999,
                                                                        })
                                                                    }}
                                                                    width="400px"
                                                                    isClearable
                                                                    value={selectedAuditor}
                                                                    onChange={(selectedOption) => setSelectedAuditor(selectedOption)}
                                                                    loadOptions={(inputValue, callback) => fetchClientsBySearch(inputValue, callback, ["Corporate"])}
                                                                    isSearchable={true}
                                                                    placeholder={t('auditor').toUpperCase()}
                                                                    noOptionsMessage={() => "Type Minimum 3 Letter to Search"}
                                                                />
                                                            </div>
                                                            : <span className="main-title"> {selectedAuditor?.ent_name}</span>}
                                                        <span className={`status ${selectedAuditor?.ent_status}`}>{`${t('auditor').toUpperCase()} ${t('status').toUpperCase()} ${selectedAuditor?.ent_status || ''}`}</span>
                                                    </div>
                                                    <div className="email-phone-row" style={{ display: "flex", alignCenter: "center", flexDirection: "row", width: "100%" }}>
                                                        <span className="email-phone-details" style={{ display: "flex", alignCenter: "center", flexDirection: "row", cursor: "pointer", flex: "1.8" }}>
                                                            <MdEmail className="icon" /> <span className="sub-title">{selectedAuditor?.ent_email || t('unspecified')}</span>
                                                        </span>
                                                        <span className="email-phone-details" style={{ display: "flex", alignCenter: "center", flexDirection: "row", flex: "1" }}>
                                                            <MdPhone className="icon" /> <span className="sub-title">{selectedAuditor?.ent_phone_no || t('unspecified')}</span>
                                                        </span>
                                                        <span className="email-phone-details" style={{ display: "flex", alignCenter: "center", flexDirection: "row", flex: "1" }}>
                                                            <TbCertificate className="icon" /> <span className="sub-title">{selectedAuditor?.aent_name_xx || t('unspecified')}</span>
                                                        </span>
                                                        <span className="email-phone-details"
                                                            style={{ display: "flex", alignCenter: "center", flexDirection: "row", cursor: "pointer", flex: "1" }}
                                                            onClick={() => {
                                                                try {
                                                                    navigate(`/entity/${selectedAuditor?.ent_docid}`);
                                                                } catch (error) {
                                                                    console.log(error)
                                                                }
                                                            }}>
                                                            <MdOutlineNumbers className="icon" /> <span className="sub-title">{selectedAuditor?.ent_code}</span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </motion.div>}
                                </ExpandableComponent>
                                <ExpandableComponent
                                    title={t('assetAllocation').toUpperCase()}
                                    subtitle={
                                        totalAllocation === 100 ?
                                            <span className="sub-title">{t('totalWeightsPerc', { perc: totalAllocation })}</span>
                                            :
                                            <span className={`sub-title status Rejected`}>{t('totalWeightsPerc', { perc: totalAllocation })}</span>
                                    }
                                    defaultExpanded={true}
                                >
                                    <div className="available-services">
                                        <div className="table-content">
                                            <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                                                <Table sx={{ width: "max-content", border: 'none' }}>
                                                    <TableHead className="tablehead">
                                                        <TableRow className="tablerow">
                                                            <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                                                #
                                                            </TableCell>
                                                            <TableCell className="table-cell left" style={{ width: "auto" }}>
                                                                {documentEnabled === "Y" ?
                                                                    <div className="input-item-with-label" style={{ width: "100%", gap: "5px" }}>
                                                                        <Select
                                                                            id="asset_class"
                                                                            name="asset_class"
                                                                            menuPortalTarget={document.body}
                                                                            styles={{
                                                                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                                menuPortal: base => ({
                                                                                    ...base,
                                                                                    zIndex: 9999,
                                                                                })
                                                                            }}
                                                                            width="100%"
                                                                            value={selectedAssetClass}
                                                                            onChange={(selectedOption) => {
                                                                                try {
                                                                                    setSelectedAssetClass(selectedOption);
                                                                                } catch (error) {
                                                                                    console.log(error);
                                                                                }
                                                                            }}
                                                                            options={assetClasses}
                                                                            isSearchable={true}
                                                                            placeholder={t('assetClass')}
                                                                        />
                                                                        <CircularButton
                                                                            currentTheme={currentTheme}
                                                                            onClick={async (e) => {
                                                                                try {
                                                                                    if (!selectedAssetClass) {
                                                                                        setNotifyDialogTitle("Note!");
                                                                                        setNotifyDialogText(`Please select class to add!`);
                                                                                        setIsNotifyDialogOpen(true);
                                                                                        return;
                                                                                    }

                                                                                    const res = await newRequest.post("/fund/addAssetClass",
                                                                                        {
                                                                                            fund_docid: fundDocId,
                                                                                            asset_class: selectedAssetClass?.value,
                                                                                            target_weight: 0,
                                                                                            min_weight: 0,
                                                                                            max_weight: 0,
                                                                                        });

                                                                                    if (res.data?.msg === "added") {
                                                                                        setAssetAllocation((prevParams) => [...prevParams, {
                                                                                            ...res.data?.doc,
                                                                                            target_weight: formatAmountsToDecimals(res.data?.doc?.target_weight || 0),
                                                                                            min_weight: formatAmountsToDecimals(res.data?.doc?.min_weight || 0),
                                                                                            max_weight: formatAmountsToDecimals(res.data?.doc?.max_weight || 0),
                                                                                        }]);
                                                                                        setSelectedAssetClass(null);
                                                                                        showToast("Added!", "success");
                                                                                    } else if (res.data?.msg === "exists") {
                                                                                        showToast(`${selectedAssetClass?.label} is already added to this fund`, "warning");
                                                                                    } else {
                                                                                        showToast("Error adding asset class!", "error");
                                                                                    }
                                                                                } catch (error) {
                                                                                    console.log(error);
                                                                                }
                                                                            }}
                                                                            icon={<MdAdd color="green" />} width={"35px"} height={"35px"} />
                                                                    </div>
                                                                    :
                                                                    <span>{t('assetClass').toUpperCase()}</span>}
                                                            </TableCell>
                                                            <TableCell className="table-cell right" style={{ maxWidth: "100px" }}>
                                                                <span>{`${t('target').toUpperCase()} %`}</span>
                                                            </TableCell>
                                                            <TableCell className="table-cell right" style={{ maxWidth: "100px" }}>
                                                                <span>{`${t('min').toUpperCase()} %`}</span>
                                                            </TableCell>
                                                            <TableCell className="table-cell right" style={{ maxWidth: "100px" }}>
                                                                <span>{`${t('max').toUpperCase()} %`}</span>
                                                            </TableCell>
                                                            {documentEnabled === "Y" &&
                                                                <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                                                    <span>{`${t('action').toUpperCase()}`}</span>
                                                                </TableCell>}
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody className="tablebody">
                                                        {assetAllocation?.map((row, index) => (
                                                            <TableRow
                                                                key={row?._id}
                                                                className={`${selectedAsset?._id === row?._id ? "tablerow current" : "tablerow"}`}
                                                                onClick={() => {
                                                                    try {
                                                                        setSelectedAsset(row);
                                                                    } catch (error) {
                                                                        console.log(error);
                                                                    }
                                                                }}
                                                            >
                                                                <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                                                    {index + 1}
                                                                </TableCell>
                                                                <TableCell className="table-cell left" style={{ width: "auto" }}>
                                                                    <div style={{ display: "flex", flexDirection: "column", gap: "5px", width: "100%" }}>
                                                                        <span className="sub-title">{row?.asset_class_xx} : <span className="sub-title xrsmall soft">{row?.asset_class_desc_xx}</span></span>
                                                                    </div>
                                                                </TableCell>
                                                                <TableCell className="table-cell right" style={{ maxWidth: "100px" }}>
                                                                    {documentEnabled === "Y" ?
                                                                        <div className="input-item-with-label">
                                                                            <input
                                                                                id="target_weight"
                                                                                name="target_weight"
                                                                                type="text"
                                                                                value={row?.target_weight}
                                                                                onChange={(e) => handleAssetClassChange(e, row?._id, 'target_weight')}
                                                                                onBlur={() => handleAssetClassBlur(row?._id, "target_weight")}
                                                                                style={{ width: "100%", textAlign: "right" }}
                                                                                className="form-input-item table"
                                                                            />
                                                                        </div>
                                                                        :
                                                                        <span className="sub-title">{numeral(row?.target_weight).format("0,0.00")}</span>}
                                                                </TableCell>
                                                                <TableCell className="table-cell right" style={{ maxWidth: "100px" }}>
                                                                    {documentEnabled === "Y" ?
                                                                        <div className="input-item-with-label">
                                                                            <input
                                                                                id="min_weight"
                                                                                name="min_weight"
                                                                                type="text"
                                                                                value={row?.min_weight}
                                                                                onChange={(e) => handleAssetClassChange(e, row?._id, 'min_weight')}
                                                                                onBlur={() => handleAssetClassBlur(row?._id, "min_weight")}
                                                                                style={{ width: "100%", textAlign: "right" }}
                                                                                className="form-input-item table"
                                                                            />
                                                                        </div>
                                                                        :
                                                                        <span className="sub-title">{numeral(row?.min_weight).format("0,0.00")}</span>}
                                                                </TableCell>
                                                                <TableCell className="table-cell right" style={{ maxWidth: "100px" }}>
                                                                    {documentEnabled === "Y" ?
                                                                        <div className="input-item-with-label">
                                                                            <input
                                                                                id="max_weight"
                                                                                name="max_weight"
                                                                                type="text"
                                                                                value={row?.max_weight}
                                                                                onChange={(e) => handleAssetClassChange(e, row?._id, 'max_weight')}
                                                                                onBlur={() => handleAssetClassBlur(row?._id, "max_weight")}
                                                                                style={{ width: "100%", textAlign: "right" }}
                                                                                className="form-input-item table"
                                                                            />
                                                                        </div>
                                                                        :
                                                                        <span className="sub-title">{numeral(row?.max_weight).format("0,0.00")}</span>}
                                                                </TableCell>
                                                                {documentEnabled === "Y" &&
                                                                    <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                                                        <CircularButton
                                                                            currentTheme={currentTheme}
                                                                            onClick={async (e) => {
                                                                                try {
                                                                                    const res = await newRequest.post("/fund/removeAssetClass",
                                                                                        {
                                                                                            fund_docid: fundDocId,
                                                                                            asset_class: row?.asset_class
                                                                                        });

                                                                                    if (res.data?.msg === "removed") {
                                                                                        setAssetAllocation((prevData) =>
                                                                                            prevData.filter(doc => doc?.asset_class !== row?.asset_class)
                                                                                        );

                                                                                        showToast("Deleted!", "success");
                                                                                    } else {
                                                                                        showToast("Error deleting report!", "error");
                                                                                    }
                                                                                } catch (error) {
                                                                                    console.log(error);
                                                                                }
                                                                            }} color="#E53935" icon={<MdDelete/>} width={"35px"} height={"35px"} />
                                                                    </TableCell>}
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </div>
                                    </div>
                                    <hr className="separator-h" style={{ margin: "3px 0px" }} />
                                    <div style={{ display: "flex", flexDirection: "row", gap: "5px", alignItems: "center", justifyContent: "space-between" }}>
                                        <span className="sub-title">{t('rebalancingRule').toUpperCase()}</span>
                                        <span />
                                    </div>
                                    <div style={{ display: "flex", flexDirection: "row", gap: "5px", marginTop: "10px", alignItems: "center", justifyContent: "space-between" }}>
                                        <div className="input-item-with-label" style={{ flex: "1.3" }}>
                                            <label htmlFor="rebalance_method"
                                                className="form-input-label"
                                                style={{ width: "max-content" }}>
                                                {t('method').toUpperCase()}
                                            </label>
                                            <Select
                                                id="rebalance_method"
                                                name="rebalance_method"
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                    menuPortal: base => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                    })
                                                }}
                                                width="100%"
                                                value={rebalanceMethods.find(option => option.value === fundData?.rebalance_method) || null}
                                                onChange={selectedOption => handleSetFundData("rebalance_method", selectedOption?.value)}
                                                options={rebalanceMethods}
                                                isSearchable={true}
                                                placeholder={t('method')}
                                                isDisabled={documentEnabled === "N"}
                                            />
                                        </div>
                                        <div className="input-item-with-label" style={{ flex: "1.3" }}>
                                            <label htmlFor="rebalance_frequency"
                                                className="form-input-label"
                                                style={{ width: "max-content" }}>
                                                {t('frequency').toUpperCase()}
                                            </label>
                                            <Select
                                                id="rebalance_frequency"
                                                name="rebalance_frequency"
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                    menuPortal: base => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                    })
                                                }}
                                                width="100%"
                                                value={frequencies.find(option => option.value === fundData?.rebalance_frequency) || null}
                                                onChange={selectedOption => handleSetFundData("rebalance_frequency", selectedOption?.value)}
                                                options={frequencies}
                                                isSearchable={true}
                                                placeholder={t('frequency')}
                                                isDisabled={documentEnabled === "N"}
                                            />
                                        </div>
                                        <div className="input-item-with-label" style={{ flex: "1", justifyContent: "flex-end" }}>
                                            <label htmlFor="rebalance_threshold"
                                                className="form-input-label"
                                                style={{ width: "max-content" }}>
                                                {t('threshold').toUpperCase()} [%]
                                            </label>
                                            <input
                                                name="rebalance_threshold"
                                                type="text"
                                                placeholder="0.00"
                                                className="form-input-item"
                                                style={{ width: "100px", textAlign: "right" }}
                                                value={fundData?.rebalance_threshold}
                                                onChange={(e) => {
                                                    try {
                                                        handleSetFundData("rebalance_threshold", e.target.value);
                                                    } catch (error) {
                                                        console.log(error);
                                                    }
                                                }}
                                                disabled={documentEnabled === "N"}
                                                onBlur={(e) => {
                                                    try {
                                                        if (e.target.value) {
                                                            const strippedValue = e.target.value.replace(/,/g, "");
                                                            if (isNaN(strippedValue)) {
                                                                setNotifyDialogTitle(t('error'));
                                                                setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
                                                                setIsNotifyDialogOpen(true);
                                                                return;
                                                            }
                                                            handleSetFundData("rebalance_threshold", formatAmountsToDecimals(strippedValue || 0));
                                                        }
                                                    } catch (error) {
                                                        console.log(error)
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </ExpandableComponent>
                                <ExpandableComponent
                                    title={t('fees').toUpperCase()}
                                    subtitle={documentEnabled === "Y" ?
                                        <div className="input-item-with-label" style={{ width: "100%", gap: "5px" }}>
                                            <Select
                                                id="fee"
                                                name="fee"
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                    menuPortal: base => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                    })
                                                }}
                                                width="100%"
                                                value={selectedDefinedFee}
                                                onChange={(selectedOption) => {
                                                    try {
                                                        setSelectedDefinedFee(selectedOption);
                                                    } catch (error) {
                                                        console.log(error);
                                                    }
                                                }}
                                                options={definedFees}
                                                isSearchable={true}
                                                placeholder={t('fee')}
                                            />
                                            <CircularButton
                                                currentTheme={currentTheme}
                                                onClick={async (e) => {
                                                    try {
                                                        if (!selectedDefinedFee) {
                                                            setNotifyDialogTitle("Note!");
                                                            setNotifyDialogText(`Please select fee to add!`);
                                                            setIsNotifyDialogOpen(true);
                                                            return;
                                                        }

                                                        const res = await newRequest.post("/fund/addFundFee",
                                                            {
                                                                fund_docid: fundDocId,
                                                                fee_code: selectedDefinedFee?.value,
                                                                rate: 0,
                                                                rate_type: "Percentage",
                                                                rate_frequency: "Monthly",
                                                                applicable_on: "AUM",
                                                                trigger_condition: "On EOM",
                                                            });

                                                        if (res.data?.msg === "added") {
                                                            setFees((prevData) => [...prevData, {
                                                                ...res.data?.doc,
                                                                rate: formatAmountsToDecimals(res.data?.doc?.rate || 0)
                                                            }]);
                                                            setSelectedDefinedFee(null);
                                                            showToast("Added!", "success");
                                                        } else if (res.data?.msg === "exists") {
                                                            showToast(`${selectedDefinedFee?.label} is already added to this fund`, "warning");
                                                        } else {
                                                            showToast("Error adding fee!", "error");
                                                        }
                                                    } catch (error) {
                                                        console.log(error);
                                                    }
                                                }}
                                                icon={<MdAdd color="green" />} width={"35px"} height={"35px"} />
                                        </div>
                                        :
                                        <span />}
                                    defaultExpanded={fees?.length > 0}
                                >
                                    <div className="available-services">
                                        <div className="table-content">
                                            <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                                                <Table sx={{ width: "max-content", border: 'none' }}>
                                                    {/* <TableHead className="tablehead">
                                                        <TableRow className="tablerow">
                                                            <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                                                #
                                                            </TableCell>
                                                            <TableCell className="table-cell left" style={{ width: "auto" }}>
                                                                {documentEnabled === "Y" ?
                                                                    <div className="input-item-with-label" style={{ width: "100%", gap: "5px" }}>
                                                                        <Select
                                                                            id="fee"
                                                                            name="fee"
                                                                            menuPortalTarget={document.body}
                                                                            styles={{
                                                                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                                menuPortal: base => ({
                                                                                    ...base,
                                                                                    zIndex: 9999,
                                                                                })
                                                                            }}
                                                                            width="100%"
                                                                            value={selectedDefinedFee}
                                                                            onChange={(selectedOption) => {
                                                                                try {
                                                                                    setSelectedDefinedFee(selectedOption);
                                                                                } catch (error) {
                                                                                    console.log(error);
                                                                                }
                                                                            }}
                                                                            options={definedFees}
                                                                            isSearchable={true}
                                                                            placeholder={t('fee')}
                                                                        />
                                                                        <CircularButton
                                                                            currentTheme={currentTheme}
                                                                            onClick={async (e) => {
                                                                                try {
                                                                                    if (!selectedDefinedFee) {
                                                                                        setNotifyDialogTitle("Note!");
                                                                                        setNotifyDialogText(`Please select fee to add!`);
                                                                                        setIsNotifyDialogOpen(true);
                                                                                        return;
                                                                                    }

                                                                                    const res = await newRequest.post("/fund/addFundFee",
                                                                                        {
                                                                                            fund_docid: fundDocId,
                                                                                            fee_code: selectedDefinedFee?.value,
                                                                                            rate: 0,
                                                                                            rate_type: "Percentage",
                                                                                            rate_frequency: "Monthly",
                                                                                            applicable_on: "AUM",
                                                                                            trigger_condition: "On EOM",
                                                                                        });

                                                                                    if (res.data?.msg === "added") {
                                                                                        setFees((prevData) => [...prevData, {
                                                                                            ...res.data?.doc,
                                                                                            rate: formatAmountsToDecimals(res.data?.doc?.rate || 0)
                                                                                        }]);
                                                                                        setSelectedDefinedFee(null);
                                                                                        showToast("Added!", "success");
                                                                                    } else if (res.data?.msg === "exists") {
                                                                                        showToast(`${selectedDefinedFee?.label} is already added to this fund`, "warning");
                                                                                    } else {
                                                                                        showToast("Error adding fee!", "error");
                                                                                    }
                                                                                } catch (error) {
                                                                                    console.log(error);
                                                                                }
                                                                            }}
                                                                            icon={<MdAdd color="green" />} width={"35px"} height={"35px"} />
                                                                    </div>
                                                                    :
                                                                    <span>{t('fee').toUpperCase()}</span>}
                                                            </TableCell>
                                                            <TableCell className="table-cell center" style={{ maxWidth: documentEnabled === "Y" ? "500px" : "650px" }}>
                                                                <span>{`${t('details').toUpperCase()}`}</span>
                                                            </TableCell>
                                                            {documentEnabled === "Y" &&
                                                                <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                                                    <span>{`${t('action').toUpperCase()}`}</span>
                                                                </TableCell>}
                                                        </TableRow>
                                                    </TableHead> */}
                                                    <TableBody className="tablebody">
                                                        {slicedFees?.map((row, index) => (
                                                            <TableRow
                                                                key={row?._id}
                                                                className={`${selectedFee?._id === row?._id ? "tablerow current" : "tablerow"}`}
                                                                onClick={() => {
                                                                    try {
                                                                        setSelectedFee(row);
                                                                    } catch (error) {
                                                                        console.log(error);
                                                                    }
                                                                }}
                                                            >
                                                                <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                                                    {currentFeesPage * rowsPerPageFees + index + 1}
                                                                </TableCell>
                                                                <TableCell className="table-cell left" style={{ width: "auto" }}>
                                                                    <div style={{ display: "flex", flexDirection: "column", gap: "2px", width: "100%" }}>
                                                                        <span className="sub-title">{row?.fee_name_xx}</span>
                                                                        <span className="sub-title" style={{ fontSize: "10px" }}>{row?.fee_category_xx}</span>
                                                                        <span className="sub-title soft" style={{ fontSize: "10px" }}>{row?.fee_code}</span>
                                                                    </div>
                                                                </TableCell>
                                                                <TableCell className="table-cell" style={{ maxWidth: documentEnabled === "Y" ? "500px" : "650px" }}>
                                                                    <div style={{ display: "flex", flexDirection: "column", width: "100%", gap: "5px" }}>
                                                                        <div style={{ display: "flex", flexDirection: "row", width: "100%", gap: "5px", alignItems: "center", justifyContent: "space-between" }}>
                                                                            <div style={{ display: "flex", flexDirection: "column", flex: "1", gap: "5px" }}>
                                                                                {documentEnabled === "Y" ?
                                                                                    <div className="input-item-with-label">
                                                                                        <label
                                                                                            className="form-dropdown-label"
                                                                                            style={{ width: "70px" }}
                                                                                        >
                                                                                            {t('rate')}
                                                                                        </label>
                                                                                        <input
                                                                                            id={`rate_${row?._id}`}
                                                                                            name={`rate_${row?._id}`}
                                                                                            type="text"
                                                                                            value={row?.rate}
                                                                                            onChange={(e) => handleFundFeeChange(e, row?._id, 'rate')}
                                                                                            onBlur={() => handleFundFeeBlur(row?._id, "rate")}
                                                                                            style={{ width: "150px", textAlign: "right" }}
                                                                                            className="form-input-item table"
                                                                                        />
                                                                                    </div>
                                                                                    :
                                                                                    <span className="sub-title">{`${t('rate')} : ${row?.rate_type === "Fixed Amount" ? fundData?.base_currency : ""} ${numeral(row?.rate).format("0,0.00")} ${row?.rate_type === "Percentage" ? "%" : ""}`}</span>}
                                                                                {documentEnabled === "Y" ?
                                                                                    <div className="input-item-with-label">
                                                                                        <label
                                                                                            className="form-dropdown-label"
                                                                                            style={{ width: "70px" }}
                                                                                        >
                                                                                            {t('freq')}
                                                                                        </label>
                                                                                        <Select
                                                                                            id={`rate_frequency_${row?._id}`}
                                                                                            name={`rate_frequency_${row?._id}`}
                                                                                            menuPortalTarget={document.body}
                                                                                            styles={{
                                                                                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                                                menuPortal: base => ({
                                                                                                    ...base,
                                                                                                    zIndex: 9999,
                                                                                                })
                                                                                            }}
                                                                                            width="150px"
                                                                                            height="36px"
                                                                                            options={fundRateFrequencies}
                                                                                            isSearchable={true}
                                                                                            placeholder={t('frequency')}
                                                                                            value={fundRateFrequencies.find(option => option.value === row?.rate_frequency) || null}
                                                                                            onChange={(selectedOption) => handleFundFeeChange(selectedOption, row?._id, 'rate_frequency')}
                                                                                        />
                                                                                    </div>
                                                                                    :
                                                                                    <span className="sub-title">{`${t('freq')} : ${row?.rate_frequency}`}</span>}
                                                                            </div>
                                                                            <div style={{ display: "flex", flexDirection: "column", flex: "1", gap: "5px" }}>
                                                                                {documentEnabled === "Y" ?
                                                                                    <div className="input-item-with-label">
                                                                                        <label
                                                                                            className="form-dropdown-label"
                                                                                            style={{ width: "70px" }}
                                                                                        >
                                                                                            {t('type')}
                                                                                        </label>
                                                                                        <Select
                                                                                            id={`rate_type_${row?._id}`}
                                                                                            name={`rate_type_${row?._id}`}
                                                                                            menuPortalTarget={document.body}
                                                                                            styles={{
                                                                                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                                                menuPortal: base => ({
                                                                                                    ...base,
                                                                                                    zIndex: 9999,
                                                                                                })
                                                                                            }}
                                                                                            width="150px"
                                                                                            height="36px"
                                                                                            options={fundRateTypes}
                                                                                            isSearchable={true}
                                                                                            placeholder={t('type')}
                                                                                            value={fundRateTypes.find(option => option.value === row?.rate_type) || null}
                                                                                            onChange={(selectedOption) => handleFundFeeChange(selectedOption, row?._id, 'rate_type')}
                                                                                        />
                                                                                    </div>
                                                                                    :
                                                                                    <span className="sub-title">{`${t('type')} : ${row?.rate_type}`}</span>}
                                                                                {documentEnabled === "Y" ?
                                                                                    <div className="input-item-with-label">
                                                                                        <label
                                                                                            className="form-dropdown-label"
                                                                                            style={{ width: "70px" }}
                                                                                        >
                                                                                            {t('applyOn')}
                                                                                        </label>
                                                                                        <Select
                                                                                            id={`applicable_on_${row?._id}`}
                                                                                            name={`applicable_on_${row?._id}`}
                                                                                            menuPortalTarget={document.body}
                                                                                            styles={{
                                                                                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                                                menuPortal: base => ({
                                                                                                    ...base,
                                                                                                    zIndex: 9999,
                                                                                                })
                                                                                            }}
                                                                                            width="150px"
                                                                                            height="36px"
                                                                                            options={fundRateApplOn}
                                                                                            isSearchable={true}
                                                                                            placeholder={t('applyOn')}
                                                                                            value={fundRateApplOn.find(option => option.value === row?.applicable_on) || null}
                                                                                            onChange={(selectedOption) => handleFundFeeChange(selectedOption, row?._id, 'applicable_on')}
                                                                                        />
                                                                                    </div>
                                                                                    :
                                                                                    <span className="sub-title">{`${t('applyOn')} : ${row?.applicable_on}`}</span>}
                                                                            </div>
                                                                        </div>
                                                                        {documentEnabled === "Y" ?
                                                                            <div className="input-item-with-label">
                                                                                <label
                                                                                    className="form-dropdown-label"
                                                                                    style={{ width: "80px" }}
                                                                                >
                                                                                    {t('trigger')}
                                                                                </label>
                                                                                <Select
                                                                                    id={`trigger_condition_${row?._id}`}
                                                                                    name={`trigger_condition_${row?._id}`}
                                                                                    menuPortalTarget={document.body}
                                                                                    styles={{
                                                                                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                                        menuPortal: base => ({
                                                                                            ...base,
                                                                                            zIndex: 9999,
                                                                                        })
                                                                                    }}
                                                                                    width="100%"
                                                                                    height="36px"
                                                                                    options={triggerConditions}
                                                                                    isSearchable={true}
                                                                                    placeholder={t('trigger')}
                                                                                    value={triggerConditions.find(option => option.value === row?.trigger_condition) || null}
                                                                                    onChange={(selectedOption) => handleFundFeeChange(selectedOption, row?._id, 'trigger_condition')}
                                                                                />
                                                                            </div>
                                                                            :
                                                                            <span className="sub-title">{`${t('trigger')} : ${row?.trigger_condition}`}</span>}
                                                                    </div>
                                                                </TableCell>
                                                                {documentEnabled === "Y" &&
                                                                    <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                                                        <CircularButton
                                                                            currentTheme={currentTheme}
                                                                            onClick={async (e) => {
                                                                                try {
                                                                                    const res = await newRequest.post("/fund/removeFundFee",
                                                                                        {
                                                                                            fund_docid: fundDocId,
                                                                                            fee_code: row?.fee_code
                                                                                        });

                                                                                    if (res.data?.msg === "removed") {
                                                                                        setFees((prevData) =>
                                                                                            prevData.filter(doc => doc?.fee_code !== row?.fee_code)
                                                                                        );

                                                                                        showToast("Deleted!", "success");
                                                                                    } else {
                                                                                        showToast("Error deleting report!", "error");
                                                                                    }
                                                                                } catch (error) {
                                                                                    console.log(error);
                                                                                }
                                                                            }} color="#E53935" icon={<MdDelete/>} width={"30px"} height={"30px"} />
                                                                    </TableCell>}
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                                <TablePagination
                                                    rowsPerPageOptions={[3]}
                                                    rowsPerPage={rowsPerPageFees}
                                                    onRowsPerPageChange={handleFeesRowsPerPage}
                                                    component="div"
                                                    count={fees?.length}
                                                    rows={fees}
                                                    page={currentFeesPage}
                                                    onPageChange={handleFeesPageChange}
                                                />
                                            </TableContainer>
                                        </div>
                                    </div>
                                </ExpandableComponent>
                                {/* ADD MORE CONTENT HERE */}
                            </div>
                        </div>
                        <div className="summary-wrapper">
                            <div className="summary-content">
                                <div className="logo">
                                    {fundData?.fund_logo_url ?
                                        <img src={fundData?.fund_logo_url} alt="" className="logo" /> : <CiImageOn style={{ height: "120px", width: "120px" }} />}
                                    <input
                                        type="file"
                                        id="file"
                                        style={{ display: "none" }}
                                        accept="image/*"
                                        onChange={(e) => setImg(e.target.files[0])}
                                    />
                                    {fundData?.fund_status !== "Active" &&
                                        <label htmlFor="file" style={{ cursor: "pointer" }}>
                                            <h1 className="sub-title">{fundData?.fund_logo_url ? t('changeLogo') : t('selectLogo')}</h1>
                                        </label>}
                                </div>
                                <hr className="separator-h" />
                                <h1 className="sub-title" style={{ alignSelf: "center" }}>{t('timeline').toUpperCase()}</h1>
                                <hr className="separator-h" />
                                <div className="timeline-root">
                                    {traceData.map((item) => (
                                        <div key={item?._id} className="timeline-item">
                                            <div className="timeline-separator">
                                                <div className="timeline-dot"></div>
                                                <div className="timeline-connector" />
                                            </div>
                                            <div className="timeline-content">
                                                <div className="timeline-navbar">
                                                    <div className="avatar-container">
                                                        {item?.updated_by_photo_url_xx ?
                                                            <img src={item?.updated_by_photo_url_xx} alt="" className="avatar" />
                                                            :
                                                            <CiImageOn style={{ width: "30px", height: "30px" }} />}
                                                        <span className="username">{item?.updated_by_name_xx}</span>
                                                    </div>
                                                    <span className="time-ago">{item?.time_ago_xx}</span>
                                                </div>
                                                <div className="remarks">
                                                    {item?.trc_remarks}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>)}
            {/* Dialog to notify user about changes being saved */}
            <Dialog open={isNotifyDialogOpen}
                onClose={() => setIsNotifyDialogOpen(false)}
                PaperProps={{
                    sx: {
                        backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
                        color: currentTheme === "dark" ? "#fff" : "#000",
                    },
                }}
                slotProps={{
                    backdrop: {
                        sx: {
                            backgroundColor: "rgba(0, 0, 0, 0.7)",
                        },
                    },
                }}>
                <DialogTitle>{notifyDialogTitle}</DialogTitle>
                <DialogContent>
                    <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
                </DialogContent>
                <DialogActions>
                    <CustomLoadingButton currentTheme={currentTheme} onClick={() => setIsNotifyDialogOpen(false)}>{t('close')}</CustomLoadingButton>
                </DialogActions>
            </Dialog>
            {validationMsgDialog && (
                <motion.div
                    className="overlay-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="overlay-wrapper">
                        <div className="overlay-navbar">
                            <h1 className="main-title">{t('messages')}</h1>
                            <CircularButton
                                currentTheme={currentTheme}
                                onClick={() => {
                                    try {
                                        setValidationMsgDialog(false);
                                    } catch (error) {
                                        console.log(error);
                                    }
                                }} icon={<MdClose />} width={"35px"} height={"35px"} />
                        </div>
                        <div className="overlay-content">
                            <ValidationMessages messageData={validationMessagesResult} />
                        </div>
                    </div>
                </motion.div>
            )}

            {/* Confirm Dialog */}
            <ConfirmDialog
                isOpen={isConfirmDialogOpen}
                onClose={() => setIsConfirmDialogOpen(false)}
                onConfirm={handleConfirm}
                dialogTitle={t('confirmation')}
                dialogContent={<p dangerouslySetInnerHTML={{ __html: confirmationActiontext }} />}
            />
            {reportsDialogOpen && (
                <motion.div
                    className="overlay-dialog reports"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="overlay-wrapper">
                        <div className="overlay-navbar">
                            <span className="main-title">{t('reports')}</span>
                            <CircularButton currentTheme={currentTheme} onClick={() => setReportsDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
                        </div>
                        <div className="overlay-content">
                            <OnScreenReports
                                reportGroupArray={fundData?.report_keys_array}
                                documentData={{
                                    docNo: "",
                                    docType: "AM Fund",
                                    docId: fundDocId,
                                }} />
                        </div>
                    </div>
                </motion.div>)}
            {isProcessing && (
                <motion.div
                    className="processing-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="processing-wrapper">
                        <GridLoader
                            color="#F44336"
                            style={{
                                height: "50px",
                                width: "50px",
                            }}
                        />
                    </div>
                </motion.div>
            )}
            {/* progress dialog for file upload  */}
            <UploadDialog
                open={isDialogOpen}
                handleClose={() => setIsDialogOpen(false)}
                uploadProgress={uploadProgress}
            />
        </motion.div >
    )
};

export default AmFund